<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("usermanagement")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="12">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="12" md="5" class="pa-2">
                    <v-text-field
                      id="username-field-search-usermanagement"
                      :label="$t('username')"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-text-box-search-outline"
                      hide-details
                      clearable
                      v-model="username"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" class="pa-2">
                    <v-text-field
                      id="email-field-search-usermanagement"
                      :label="$t('email')"
                      v-model="email"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-email-outline"
                      hide-details
                      clearable
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    class="pa-2 d-flex align-center justify-end"
                  >
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="12" class="d-flex flex-wrap justify-end gap-2">
              <div class="action-controls">
                <!-- Template Button -->
                <v-btn
                  v-if="canAdd"
                  id="button-downloadtemplate-usermanagement"
                  color="info"
                  class="control-btn template-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  prepend-icon="mdi-file-export"
                  @click="flagTemplate = true"
                >
                  <span class="btn-text">Template</span>
                  <v-tooltip activator="parent" location="top">
                    Download Template
                  </v-tooltip>
                </v-btn>

                <!-- Import Button -->
                <v-btn
                  v-if="canAdd"
                  id="button-import-usermanagement"
                  color="info"
                  class="control-btn import-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  prepend-icon="mdi-table-arrow-left"
                  @click="triggerFileUpload"
                >
                  <span class="btn-text">Import</span>
                  <v-tooltip activator="parent" location="top">
                    Import File
                  </v-tooltip>
                </v-btn>

                <!-- Hidden File Component -->
                <DragDropFile
                  ref="fileUploader"
                  :dialog="true"
                  :DragDrop="false"
                  :ShowListFile="false"
                  :accept="accept"
                  @filesUploaded="processUpload($event)"
                  :allowType="[]"
                  class="d-none"
                />

                <!-- Divider -->
                <v-divider
                  vertical
                  thickness="1"
                  length="50"
                  class="mx-4"
                ></v-divider>

                <!-- Add User Button -->
                <v-btn
                  v-if="canAdd"
                  id="button-add-usermanagement"
                  color="primary"
                  class="control-btn create-btn"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-plus-circle"
                  rounded="xl"
                  @click="
                    Adddialog = true;
                    mailcheck = false;
                    phonecheck = false;
                    checkLengthPassword = true;
                    checkLowercaseLetter = true;
                    checkUppercaseLetter = true;
                    checkNumber = true;
                    checkSpecialCharacter = true;
                    checkPasswordMatch = true;
                    user.password = null;
                    user.confirmpassword = null;
                  "
                >
                  <span class="btn-text">{{ $t("add") }}</span>
                  <v-tooltip activator="parent" location="top">
                    Add New User
                  </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          class="modern-table"
          :items="filteredUsers"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.fullName }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-usermanagement"
                    v-if="
                      (item.username != currentUserId || roleId == '0') &&
                      (item.roleId != 0 || (item.roleId == 0 && roleId == '0')) &&
                      (canEdit || isViewOnly)
                    "
                    variant="text"
                    density="comfortable"
                    @click="EditUser(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                    <v-tooltip activator="parent" location="top">
                      {{ canEdit ? 'Edit' : 'View' }}
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider — only when delete row is shown (business rules pass) -->
                  <div
                    class="action-divider"
                    v-if="
                      (item.username != currentUserId || roleId == '0') &&
                      (item.roleId != 0 || (item.roleId == 0 && roleId == '0')) &&
                      canEdit &&
                      canDelete &&
                      item.userId != 1 &&
                      (item.userType
                        ? item.userType.replace(/\s/g, '') != 'Owner'
                        : true)
                    "
                  ></div>

                  <!-- Delete — visible when business rules pass; disabled when !canDelete to preserve column layout -->
                  <v-btn
                    id="button-delete-popupedit-usermanagement"
                    v-if="
                      (item.username != currentUserId || roleId == '0') &&
                      canDelete &&
                      item.userId != 1 &&
                      (item.userType
                        ? item.userType.replace(/\s/g, '') != 'Owner'
                        : true)
                    "
                    variant="text"
                    density="comfortable"
                    @click="DeleteUser(item)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>

                  <!-- Current User Badge -->
                  <v-chip
                    v-if="item.username == currentUserId && roleId != '0'"
                    size="small"
                    color="primary"
                    variant="tonal"
                    prepend-icon="mdi-account-check"
                  >
                    You
                  </v-chip>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- EditUserDialog -->
    <v-dialog
      v-model="Editdialog"
      max-width="800px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon color="white" size="28"
                  >{{ canEdit ? 'mdi-account-edit-outline' : 'mdi-eye-outline' }}</v-icon
                >
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t("usermanagement") }}</h2>
              <p class="dialog-subtitle">{{ canEdit ? 'Edit user account information' : 'View user account information' }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              @click="Editdialog = false"
              color="white"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="edit-user-content">
          <v-container fluid>
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-account-outline</v-icon
                >
                Basic Information
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Username (Read Only)</label>
                    <v-text-field
                      :label="$t('username')"
                      :rules="[rules.required]"
                      v-model="edit.username"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      disabled
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("username") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <!-- Empty space for layout balance -->
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">First Name *</label>
                    <v-text-field
                      id="firstname-field-popupedit-usermanagement"
                      :label="$t('firstname')"
                      :rules="[rules.required]"
                      v-model="edit.firstname"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter first name"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("firstname") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Last Name *</label>
                    <v-text-field
                      id="lastname-field-popupedit-usermanagement"
                      :label="$t('lastname')"
                      :rules="[rules.required]"
                      v-model="edit.lastname"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter last name"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("lastname") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Email (Read Only)</label>
                    <v-text-field
                      :label="$t('email')"
                      :rules="[rules.required, validateEmail(edit.email)]"
                      v-model="edit.email"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      disabled
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-email-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("email") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Phone Number</label>
                    <v-text-field
                      id="phonenumber-field-popupedit-usermanagement"
                      :label="$t('phonenumber')"
                      v-model="edit.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter phone number"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-phone-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("phonenumber") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Role & Permissions Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-shield-account-outline</v-icon
                >
                Role & Permissions
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">User Role *</label>
                    <div class="role-selection-container-compact">
                      <v-radio-group
                        id="role-radiogroup-popupedit-usermanagement"
                        v-model="edit.roleId"
                        class="role-radio-group-compact"
                        :disabled="edit.roleId == 0 && roleId != '0'"
                        hide-details
                      >
                        <!-- Compact Role Cards Grid -->
                        <div class="role-cards-grid">
                          <!-- Super Admin Card -->
                          <div
                            v-show="roleId == '0'"
                            class="role-card-compact"
                            :class="{
                              selected: edit.roleId === 0,
                              disabled: edit.roleId == 0 && roleId != '0',
                            }"
                            @click="
                              !(edit.roleId == 0 && roleId != '0')
                                ? (edit.roleId = 0)
                                : null
                            "
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="0"
                                class="role-radio-compact"
                                :disabled="edit.roleId == 0 && roleId != '0'"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="red"
                                >mdi-shield-crown</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <v-chip
                                size="x-small"
                                color="red"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="10">mdi-crown</v-icon>
                                {{ $t("superAdmin") }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- Admin Card -->
                          <div
                            class="role-card-compact"
                            :class="{ selected: edit.roleId === 1 }"
                            @click="edit.roleId = 1"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="1"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="orange"
                                >mdi-shield-account</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <v-chip
                                size="x-small"
                                color="orange"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="10">mdi-cog</v-icon>
                                {{ $t("admin") }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- General User Card -->
                          <div
                            class="role-card-compact"
                            :class="{ selected: edit.roleId === 2 }"
                            @click="edit.roleId = 2"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="2"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="primary"
                                >mdi-account</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <v-chip
                                size="x-small"
                                color="primary"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="10">mdi-eye</v-icon>
                                {{ $t("generalUsers") }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- Operator Card -->
                          <div
                            class="role-card-compact"
                            :class="{ selected: edit.roleId === 6 }"
                            @click="edit.roleId = 6"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="6"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="purple"
                                >mdi-account-cog</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <v-chip
                                size="x-small"
                                color="purple"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="10">mdi-monitor</v-icon>
                                {{ $t("_Operator") }}
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </v-radio-group>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Model Selection for General Users -->
              <v-row class="form-row" v-show="edit.roleId == 2">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">Available Models</label>
                    <v-autocomplete
                      id="model-field-popupedit-usermanagement"
                      :label="'Model'"
                      :items="listDDModel"
                      item-title="name"
                      item-value="modelDisplayID"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select available models"
                      v-model="edit.model"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-robot-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("_InfoModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row v-show="edit.roleId == 2">
                <!-- App Knowledge Center: Document / Meta Docs แสดงเฉพาะของ Center / ดึงรายการไม่ได้ (โหมดปิดไม่แสดง) -->
                <v-col v-if="kccCenterMode" cols="12">
                  <v-alert :type="kccDocsUnavailable || kccMetaDocsUnavailable ? 'warning' : 'info'" variant="tonal"
                    density="compact" class="text-caption">
                    {{ $t(kccDocsUnavailable || kccMetaDocsUnavailable || "kccPickerCenterOnly") }}
                  </v-alert>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Document</label>
                    <v-autocomplete
                      id="document-autocomplete-add-usermanagement"
                      :items="listDDDocument"
                      v-model="edit.vectordbName"
                      item-title="name"
                      item-value="name"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select document"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-file-document-multiple-outline</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Database integration</label>
                    <v-autocomplete
                      id="data-integration-autocomplete-add-usermanagement"
                      :items="listDDDataIntegration"
                      v-model="edit.dataIntegrationID"
                      item-title="dataName"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select database integration"
                      class="modern-input"
                    >
                    <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-database</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row v-show="edit.roleId == 2">
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Product Group Name</label>
                    <v-autocomplete
                      id="product-autocomplete-add-usermanagement"
                      :items="listDDProductGroup"
                      v-model="edit.productGroupID"
                      item-title="productGroupName"
                      item-value="productGroupID"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select product group name"
                      class="modern-input"
                    >
                    <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-wallet-giftcard</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Intent Group Name</label>
                    <v-autocomplete
                      id="intentgroup-autocomplete-add-usermanagement"
                      :items="listDDIntentGroup"
                      v-model="edit.intentGroupID"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select intent group name"
                      class="modern-input"
                    >
                    <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-comment-question-outline</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Flows</label>
                    <v-autocomplete
                      id="intentgroup-autocomplete-add-usermanagement"
                      :items="listDDFlowGroup"
                      v-model="edit.flowGroupID"
                      item-title="name"
                      item-value="flowGroupID"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select intent group name"
                      class="modern-input"
                    >
                    <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-chart-timeline-variant-shimmer</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Community Graph</label>
                    <v-autocomplete
                      id="communitygraph-autocomplete-edit-usermanagement"
                      :items="listDDCommunityGraph"
                      v-model="edit.communityGraphID"
                      item-title="communityName"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select community graph"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-graph-outline</v-icon>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Meta Community Graph</label>
                    <v-autocomplete
                      id="metacommunitygraph-autocomplete-edit-usermanagement"
                      :items="listDDMetaCommunityGraph"
                      v-model="edit.metaCommunityGraphID"
                      item-title="communityName"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select meta community graph"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-graph</v-icon>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Meta Docs</label>
                    <v-autocomplete
                      id="metadocs-autocomplete-edit-usermanagement"
                      :items="listDDMetaDoc"
                      v-model="edit.metaVectordbName"
                      item-title="vectorDbName"
                      item-value="vectorDbName"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select meta docs"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-file-document-multiple-outline</v-icon>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- Lock Status -->
              <v-row class="form-row">
                <v-col cols="12">
                  <div class="switch-wrapper">
                    <div class="switch-content">
                      <div class="switch-info">
                        <div class="lock-icon-container">
                          <v-icon
                            :color="edit.lockStatus ? 'error' : 'success'"
                            class="lock-icon"
                            :class="{
                              locked: edit.lockStatus,
                              unlocked: !edit.lockStatus,
                            }"
                          >
                            {{ edit.lockStatus ? "mdi-lock" : "mdi-lock-open" }}
                          </v-icon>
                        </div>
                        <div>
                          <div class="switch-title">
                            {{ $t("_LockStatus") }}
                          </div>
                          <div class="switch-subtitle">
                            {{
                              edit.lockStatus
                                ? "Account is locked - User cannot access the system"
                                : "Account is unlocked - User can access the system"
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control">
                        <v-switch
                          id="switch-lockstatus-popupedit-usermanagement"
                          v-model="edit.lockStatus"
                          color="error"
                          hide-details
                          inset
                          class="modern-switch"
                          :disabled="!canEdit"
                        >
                          <template v-slot:label>
                            <span
                              class="switch-label"
                              :class="{
                                'locked-text': edit.lockStatus,
                                'unlocked-text': !edit.lockStatus,
                              }"
                            >
                              {{
                                edit.lockStatus
                                  ? $t("_Locked")
                                  : $t("_Unlocked")
                              }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Custom Page Access Toggle (Admin/User only) -->
              <v-row class="form-row" v-show="[1, 2].includes(edit.roleId)">
                <v-col cols="12">
                  <div class="switch-wrapper custom-page-access-wrapper">
                    <div class="switch-content">
                      <div class="switch-info">
                        <div class="lock-icon-container">
                          <v-icon
                            :color="edit.isCustomPageAccess ? 'primary' : 'grey'"
                            class="lock-icon"
                          >
                            mdi-shield-half-full
                          </v-icon>
                        </div>
                        <div>
                          <div class="switch-title">Custom Page Access</div>
                          <div class="switch-subtitle">
                            {{
                              edit.isCustomPageAccess
                                ? "Custom mode — Only selected pages will be accessible"
                                : "Default mode — Using standard role permissions"
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control">
                        <v-switch
                          id="switch-custompageaccess-popupedit-usermanagement"
                          v-model="edit.isCustomPageAccess"
                          color="primary"
                          hide-details
                          inset
                          class="modern-switch"
                          :disabled="!canEdit"
                        >
                          <template v-slot:label>
                            <span
                              class="switch-label"
                              :class="{
                                'text-primary': edit.isCustomPageAccess,
                                'text-grey': !edit.isCustomPageAccess,
                              }"
                            >
                              {{ edit.isCustomPageAccess ? "Enabled" : "Disabled" }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Page Selector (visible when custom access is ON) -->
              <v-row
                class="form-row"
                v-show="[1, 2].includes(edit.roleId) && edit.isCustomPageAccess"
              >
                <v-col cols="12">
                  <v-card variant="outlined" rounded="lg" class="pa-4 page-selector-card">
                    <div class="d-flex align-center justify-space-between mb-3 flex-wrap" style="gap: 12px">
                      <div class="section-title" style="font-size: 14px;">
                        <v-icon color="primary" class="mr-2" size="20">mdi-format-list-checks</v-icon>
                        Page Access
                      </div>
                      <div class="d-flex align-center bulk-actions" style="gap: 6px">
                        <v-btn
                          size="x-small"
                          variant="tonal"
                          color="amber-darken-3"
                          prepend-icon="mdi-eye-outline"
                          @click="bulkSetEditMode('view')"
                        >All View</v-btn>
                        <v-btn
                          size="x-small"
                          variant="tonal"
                          color="primary"
                          prepend-icon="mdi-pencil-outline"
                          @click="bulkSetEditMode('edit')"
                        >All Edit</v-btn>
                        <v-btn
                          size="x-small"
                          variant="text"
                          color="grey-darken-1"
                          prepend-icon="mdi-close-circle-outline"
                          @click="bulkSetEditMode('none')"
                        >Clear</v-btn>
                      </div>
                    </div>

                    <!-- Legend -->
                    <div class="mode-legend mb-3">
                      <span class="legend-item">
                        <v-icon size="14" color="amber-darken-3">mdi-eye-outline</v-icon>
                        <span>View — read-only</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="primary">mdi-plus</v-icon>
                        <span>Add</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="primary">mdi-pencil-outline</v-icon>
                        <span>Edit</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="error">mdi-delete-outline</v-icon>
                        <span>Delete</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="success">mdi-message-check-outline</v-icon>
                        <span>Full Access</span>
                      </span>
                    </div>

                    <v-divider class="mb-3" />

                    <!-- Page Tree -->
                    <div class="page-tree-container">
                      <template v-for="page in editAvailablePagesForRole" :key="page.key">
                        <!-- Group header -->
                        <div v-if="page.isGroup" class="mb-2">
                          <div class="permission-row group-row">
                            <div class="permission-label">
                              <v-icon size="18" color="primary" class="mr-2">{{ page.icon || 'mdi-folder-outline' }}</v-icon>
                              <span class="group-label-text">{{ page.label }}</span>
                              <v-chip
                                v-if="getGroupEditMode(page) === 'mixed'"
                                size="x-small"
                                color="info"
                                variant="tonal"
                                class="ml-2"
                              >Mixed</v-chip>
                            </div>
                            <v-btn-toggle
                              :model-value="getGroupEditToggleValue(page)"
                              @update:modelValue="v => setGroupEditMode(page, v)"
                              density="compact"
                              variant="outlined"
                              divided
                              class="permission-toggle"
                            >
                              <v-btn value="view" size="x-small" color="amber-darken-3" title="Grant view to all">
                                <v-icon size="14">mdi-eye-outline</v-icon>
                              </v-btn>
                              <v-btn v-if="!isGroupAllViewOnly(page)" value="edit" size="x-small" color="primary" title="Grant full edit (Add/Edit/Delete) to all">
                                <v-icon size="14">mdi-pencil-outline</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                          <!-- Children -->
                          <div class="children-container">
                            <div
                              v-for="child in page.children"
                              :key="child.key"
                              class="permission-row child-row"
                            >
                              <div class="permission-label">
                                <span class="child-label-text">{{ child.label }}</span>
                              </div>
                              <v-btn-toggle
                                :model-value="getEditPermArray(child.key, !!child.accessOnly)"
                                @update:modelValue="v => setEditPermArray(child.key, v, !!child.viewOnly, !!child.accessOnly)"
                                multiple
                                density="compact"
                                variant="outlined"
                                divided
                                class="permission-toggle"
                              >
                                <v-btn value="view" size="x-small" color="amber-darken-3" :title="child.viewOnly ? 'View (read-only page)' : (child.accessOnly ? 'View only — read-only access' : 'View only')">
                                  <v-icon size="14">mdi-eye-outline</v-icon>
                                </v-btn>
                                <template v-if="!child.viewOnly && !child.accessOnly">
                                  <v-btn value="add" size="x-small" color="primary" title="Can add">
                                    <v-icon size="14">mdi-plus</v-icon>
                                  </v-btn>
                                  <v-btn value="edit" size="x-small" color="primary" title="Can edit">
                                    <v-icon size="14">mdi-pencil-outline</v-icon>
                                  </v-btn>
                                  <v-btn value="delete" size="x-small" color="error" title="Can delete">
                                    <v-icon size="14">mdi-delete-outline</v-icon>
                                  </v-btn>
                                </template>
                                <template v-else-if="child.accessOnly">
                                  <v-btn value="access" size="x-small" color="success" title="Full access — can use the page">
                                    <v-icon size="14">mdi-message-check-outline</v-icon>
                                  </v-btn>
                                </template>
                              </v-btn-toggle>
                            </div>
                          </div>
                        </div>
                        <!-- Standalone page -->
                        <div v-else class="permission-row mb-1">
                          <div class="permission-label">
                            <v-icon size="18" color="grey-darken-1" class="mr-2">{{ page.icon || 'mdi-file-outline' }}</v-icon>
                            <span>{{ page.label }}</span>
                          </div>
                          <v-btn-toggle
                            :model-value="getEditPermArray(page.key, !!page.accessOnly)"
                            @update:modelValue="v => setEditPermArray(page.key, v, !!page.viewOnly, !!page.accessOnly)"
                            multiple
                            density="compact"
                            variant="outlined"
                            divided
                            class="permission-toggle"
                          >
                            <v-btn value="view" size="x-small" color="amber-darken-3" :title="page.viewOnly ? 'View (read-only page)' : (page.accessOnly ? 'View only — read-only access' : 'View only')">
                              <v-icon size="14">mdi-eye-outline</v-icon>
                            </v-btn>
                            <template v-if="!page.viewOnly && !page.accessOnly">
                              <v-btn value="add" size="x-small" color="primary" title="Can add">
                                <v-icon size="14">mdi-plus</v-icon>
                              </v-btn>
                              <v-btn value="edit" size="x-small" color="primary" title="Can edit">
                                <v-icon size="14">mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn value="delete" size="x-small" color="error" title="Can delete">
                                <v-icon size="14">mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                            <template v-else-if="page.accessOnly">
                              <v-btn value="access" size="x-small" color="success" title="Full access — can use the page">
                                <v-icon size="14">mdi-message-check-outline</v-icon>
                              </v-btn>
                            </template>
                          </v-btn-toggle>
                        </div>
                      </template>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-btn
                v-if="canEdit"
                id="button-changepassword-popupedit-usermanagement"
                variant="outlined"
                color="blue"
                @click="
                  changPasswordDialog = true;
                  edit.password = '';
                  edit.confirmpassword = '';
                  checkLengthPassword = true;
                  checkLowercaseLetter = true;
                  checkUppercaseLetter = true;
                  checkNumber = true;
                  checkSpecialCharacter = true;
                  checkPasswordMatch = true;
                "
                class="dialog-action-btn"
              >
                <v-icon start>mdi-lock-reset</v-icon>
                Change Password
              </v-btn>
            </div>
            <div class="actions-right">
              <v-btn
                id="button-close-popupedit-usermanagement"
                variant="outlined"
                color="grey"
                @click="Editdialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon start>mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
              <v-btn
                v-if="canEdit"
                id="button-save-popupedit-usermanagement"
                variant="elevated"
                @click="UpdateUser"
                class="dialog-action-btn save-btn-edit"
              >
                <v-icon start>mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AddUserDialog -->
    <v-dialog
      ref="form"
      v-model="Adddialog"
      max-width="800px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="28" color="white"
                  >mdi-account-plus-outline</v-icon
                >
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Add New User</h2>
              <p class="dialog-subtitle">
                Create a new user account with required information
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              @click="closeadd"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="add-user-content">
          <v-container fluid>
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-account-outline</v-icon
                >
                Basic Information
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">Username *</label>
                    <v-text-field
                      id="username-field-add-usermanagement"
                      ref="username"
                      v-model="user.username"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter username"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("username") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">First Name *</label>
                    <v-text-field
                      id="firstname-field-add-usermanagement"
                      ref="firstname"
                      v-model="user.firstname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter first name"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Last Name *</label>
                    <v-text-field
                      id="lastname-field-add-usermanagement"
                      ref="lastname"
                      v-model="user.lastname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter last name"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Email *</label>
                    <v-text-field
                      id="email-field-add-usermanagement"
                      ref="email"
                      v-model="user.email"
                      :rules="[rules.required, validateEmail(user.email)]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter email address"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-email-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Phone Number</label>
                    <v-text-field
                      id="phonenumber-field-add-usermanagement"
                      ref="phone"
                      v-model="user.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter phone number"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-phone-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Password Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-lock-outline</v-icon>
                Password Setup
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Password *</label>
                    <v-text-field
                      id="password-field-add-usermanagement"
                      ref="password"
                      v-model="user.password"
                      :rules="[rules.required]"
                      :type="show1 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show1 = !show1"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show1 ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements -->
                    <div class="password-requirements" v-if="user.password">
                      <div
                        class="requirement-item"
                        :class="{ valid: checkLengthPassword }"
                      >
                        <v-icon
                          size="12"
                          :color="checkLengthPassword ? 'success' : 'error'"
                        >
                          {{ checkLengthPassword ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>At least 8 characters</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkLowercaseLetter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkLowercaseLetter ? 'success' : 'error'"
                        >
                          {{ checkLowercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Lowercase letter</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkUppercaseLetter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkUppercaseLetter ? 'success' : 'error'"
                        >
                          {{ checkUppercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Uppercase letter</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkNumber }"
                      >
                        <v-icon
                          size="12"
                          :color="checkNumber ? 'success' : 'error'"
                        >
                          {{ checkNumber ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Number</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkSpecialCharacter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkSpecialCharacter ? 'success' : 'error'"
                        >
                          {{
                            checkSpecialCharacter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>Special character</span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Confirm Password *</label>
                    <v-text-field
                      id="confirmpassword-field-add-usermanagement"
                      ref="confirmpassword"
                      v-model="user.confirmpassword"
                      :rules="[rules.required]"
                      :type="show2 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Confirm password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show2 = !show2"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show2 ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator -->
                    <div class="password-match" v-if="user.confirmpassword">
                      <div
                        class="requirement-item"
                        :class="{ valid: checkPasswordMatch }"
                      >
                        <v-icon
                          size="12"
                          :color="checkPasswordMatch ? 'success' : 'error'"
                        >
                          {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Passwords match</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Role & Permissions Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-shield-account-outline</v-icon
                >
                Role & Permissions
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">User Role *</label>
                    <div class="role-selection-container-compact">
                      <v-radio-group
                        id="role-radiogroup-add-usermanagement"
                        v-model="user.roleId"
                        class="role-radio-group-compact"
                        hide-details
                      >
                        <!-- Compact Role Cards Grid -->
                        <div class="role-cards-grid">
                          <!-- Super Admin Card -->
                          <div
                            v-show="roleId == '0'"
                            class="role-card-compact"
                            :class="{ selected: user.roleId === 0 }"
                            @click="user.roleId = 0"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="0"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="red"
                                >mdi-shield-crown</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <!-- <h5 class="role-title-compact">{{ $t('superAdmin') }}</h5> -->
                              <v-chip
                                size="large"
                                color="red"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="18">mdi-crown</v-icon>
                                <h3>{{ $t("superAdmin") }}</h3>
                              </v-chip>
                            </div>
                          </div>

                          <!-- Admin Card -->
                          <div
                            class="role-card-compact"
                            :class="{ selected: user.roleId === 1 }"
                            @click="user.roleId = 1"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="1"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="orange"
                                >mdi-shield-account</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <!-- <h5 class="role-title-compact">{{ $t('admin') }}</h5> -->
                              <v-chip
                                size="large"
                                color="orange"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="18">mdi-cog</v-icon>
                                <h3>{{ $t("admin") }}</h3>
                              </v-chip>
                            </div>
                          </div>

                          <!-- General User Card -->
                          <div
                            class="role-card-compact"
                            :class="{ selected: user.roleId === 2 }"
                            @click="user.roleId = 2"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="2"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="primary"
                                >mdi-account</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <!-- <h5 class="role-title-compact">{{ $t('generalUsers') }}</h5> -->
                              <v-chip
                                size="large"
                                color="primary"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="10">mdi-eye</v-icon>
                                <h3>{{ $t("generalUsers") }}</h3>
                              </v-chip>
                            </div>
                          </div>

                          <!-- Operator Card -->
                          <div
                            class="role-card-compact"
                            :class="{ selected: user.roleId === 6 }"
                            @click="user.roleId = 6"
                          >
                            <div class="role-badge">
                              <v-radio
                                :value="6"
                                class="role-radio-compact"
                              ></v-radio>
                              <v-icon class="role-icon-compact" color="purple"
                                >mdi-account-cog</v-icon
                              >
                            </div>
                            <div class="role-details">
                              <!-- <h5 class="role-title-compact">{{ $t('_Operator') }}</h5> -->
                              <v-chip
                                size="large"
                                color="purple"
                                variant="tonal"
                                class="role-chip"
                              >
                                <v-icon start size="18">mdi-monitor</v-icon>
                                <h3>{{ $t("_Operator") }}</h3>
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </v-radio-group>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Model Selection for General Users -->
              <v-row class="form-row" v-show="user.roleId == 2">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">Available Models</label>
                    <v-autocomplete
                      id="model-autocomplete-add-usermanagement"
                      v-model="user.model"
                      :items="listDDModel"
                      item-title="name"
                      item-value="modelDisplayID"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select available models"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary" 
                          >mdi-robot-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="18" class="help-icon">
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("_InfoModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row v-show="user.roleId == 2">
                <!-- App Knowledge Center: Document / Meta Docs แสดงเฉพาะของ Center / ดึงรายการไม่ได้ (โหมดปิดไม่แสดง) -->
                <v-col v-if="kccCenterMode" cols="12">
                  <v-alert :type="kccDocsUnavailable || kccMetaDocsUnavailable ? 'warning' : 'info'" variant="tonal"
                    density="compact" class="text-caption">
                    {{ $t(kccDocsUnavailable || kccMetaDocsUnavailable || "kccPickerCenterOnly") }}
                  </v-alert>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Document</label>
                    <v-autocomplete
                      id="document-autocomplete-add-usermanagement"
                      :items="listDDDocument"
                      v-model="user.vectordbName"
                      item-title="name"
                      item-value="name"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select document"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-file-document-multiple-outline</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Database integration</label>
                    <v-autocomplete
                      id="data-integration-autocomplete-add-usermanagement"
                      :items="listDDDataIntegration"
                      v-model="user.dataIntegrationID"
                      item-title="dataName"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select database integration"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-database</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
 
              <v-row v-show="user.roleId == 2">
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Product Group Name</label>
                    <v-autocomplete
                      id="product-autocomplete-add-usermanagement"
                      :items="listDDProductGroup"
                      v-model="user.productGroupID"
                      item-title="productGroupName"
                      item-value="productGroupID"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select product group name"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-wallet-giftcard</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Intent Group Name</label>
                    <v-autocomplete
                      id="intentgroup-autocomplete-add-usermanagement"
                      :items="listDDIntentGroup"
                      v-model="user.intentGroupID"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select intent group name"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-comment-question-outline</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Flows</label>
                    <v-autocomplete
                      id="intentgroup-autocomplete-add-usermanagement"
                      :items="listDDFlowGroup"
                      v-model="user.flowGroupID"
                      item-title="name"
                      item-value="flowGroupID"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select intent group name"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-chart-timeline-variant-shimmer</v-icon
                        >
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Community Graph</label>
                    <v-autocomplete
                      id="communitygraph-autocomplete-add-usermanagement"
                      :items="listDDCommunityGraph"
                      v-model="user.communityGraphID"
                      item-title="communityName"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select community graph"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-graph-outline</v-icon>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Meta Community Graph</label>
                    <v-autocomplete
                      id="metacommunitygraph-autocomplete-add-usermanagement"
                      :items="listDDMetaCommunityGraph"
                      v-model="user.metaCommunityGraphID"
                      item-title="communityName"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select meta community graph"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-graph</v-icon>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">Meta Docs</label>
                    <v-autocomplete
                      id="metadocs-autocomplete-add-usermanagement"
                      :items="listDDMetaDoc"
                      v-model="user.metaVectordbName"
                      item-title="vectorDbName"
                      item-value="vectorDbName"
                      variant="outlined"
                      density="compact"
                      multiple
                      chips
                      closable-chips
                      clearable
                      hide-details="auto"
                      placeholder="Select meta docs"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-file-document-multiple-outline</v-icon>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- Lock Status -->
              <v-row class="form-row">
                <v-col cols="12">
                  <div class="switch-wrapper">
                    <div class="switch-content">
                      <div class="switch-info">
                        <div class="lock-icon-container">
                          <v-icon
                            :color="user.lockStatus ? 'error' : 'success'"
                            class="lock-icon"
                            :class="{
                              locked: user.lockStatus,
                              unlocked: !user.lockStatus,
                            }"
                          >
                            {{ user.lockStatus ? "mdi-lock" : "mdi-lock-open" }}
                          </v-icon>
                        </div>
                        <div>
                          <div class="switch-title">Account Status</div>
                          <div class="switch-subtitle">
                            {{
                              user.lockStatus
                                ? "Account is locked - User cannot access the system"
                                : "Account is unlocked - User can access the system"
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control">
                        <v-switch
                          id="lockstatus-switch-add-usermanagement"
                          v-model="user.lockStatus"
                          color="error"
                          hide-details
                          inset
                          class="modern-switch"
                        >
                          <template v-slot:label>
                            <span
                              class="switch-label"
                              :class="{
                                'locked-text': user.lockStatus,
                                'unlocked-text': !user.lockStatus,
                              }"
                            >
                              {{
                                user.lockStatus
                                  ? $t("_Locked")
                                  : $t("_Unlocked")
                              }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Custom Page Access Toggle (Admin/User only) -->
              <v-row class="form-row" v-show="[1, 2].includes(user.roleId)">
                <v-col cols="12">
                  <div class="switch-wrapper custom-page-access-wrapper">
                    <div class="switch-content">
                      <div class="switch-info">
                        <div class="lock-icon-container">
                          <v-icon
                            :color="user.isCustomPageAccess ? 'primary' : 'grey'"
                            class="lock-icon"
                          >
                            mdi-shield-half-full
                          </v-icon>
                        </div>
                        <div>
                          <div class="switch-title">Custom Page Access</div>
                          <div class="switch-subtitle">
                            {{
                              user.isCustomPageAccess
                                ? "Custom mode — Only selected pages will be accessible"
                                : "Default mode — Using standard role permissions"
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control">
                        <v-switch
                          id="switch-custompageaccess-popupadd-usermanagement"
                          v-model="user.isCustomPageAccess"
                          color="primary"
                          hide-details
                          inset
                          class="modern-switch"
                        >
                          <template v-slot:label>
                            <span
                              class="switch-label"
                              :class="{
                                'text-primary': user.isCustomPageAccess,
                                'text-grey': !user.isCustomPageAccess,
                              }"
                            >
                              {{ user.isCustomPageAccess ? "Enabled" : "Disabled" }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Page Selector (visible when custom access is ON) -->
              <v-row
                class="form-row"
                v-show="[1, 2].includes(user.roleId) && user.isCustomPageAccess"
              >
                <v-col cols="12">
                  <v-card variant="outlined" rounded="lg" class="pa-4 page-selector-card">
                    <div class="d-flex align-center justify-space-between mb-3 flex-wrap" style="gap: 12px">
                      <div class="section-title" style="font-size: 14px;">
                        <v-icon color="primary" class="mr-2" size="20">mdi-format-list-checks</v-icon>
                        Page Access
                      </div>
                      <div class="d-flex align-center bulk-actions" style="gap: 6px">
                        <v-btn
                          size="x-small"
                          variant="tonal"
                          color="amber-darken-3"
                          prepend-icon="mdi-eye-outline"
                          @click="bulkSetAddMode('view')"
                        >All View</v-btn>
                        <v-btn
                          size="x-small"
                          variant="tonal"
                          color="primary"
                          prepend-icon="mdi-pencil-outline"
                          @click="bulkSetAddMode('edit')"
                        >All Edit</v-btn>
                        <v-btn
                          size="x-small"
                          variant="text"
                          color="grey-darken-1"
                          prepend-icon="mdi-close-circle-outline"
                          @click="bulkSetAddMode('none')"
                        >Clear</v-btn>
                      </div>
                    </div>

                    <!-- Legend -->
                    <div class="mode-legend mb-3">
                      <span class="legend-item">
                        <v-icon size="14" color="amber-darken-3">mdi-eye-outline</v-icon>
                        <span>View — read-only</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="primary">mdi-plus</v-icon>
                        <span>Add</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="primary">mdi-pencil-outline</v-icon>
                        <span>Edit</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="error">mdi-delete-outline</v-icon>
                        <span>Delete</span>
                      </span>
                      <span class="legend-item">
                        <v-icon size="14" color="success">mdi-message-check-outline</v-icon>
                        <span>Full Access</span>
                      </span>
                    </div>

                    <v-divider class="mb-3" />

                    <!-- Page Tree -->
                    <div class="page-tree-container">
                      <template v-for="page in addAvailablePagesForRole" :key="page.key">
                        <!-- Group header -->
                        <div v-if="page.isGroup" class="mb-2">
                          <div class="permission-row group-row">
                            <div class="permission-label">
                              <v-icon size="18" color="primary" class="mr-2">{{ page.icon || 'mdi-folder-outline' }}</v-icon>
                              <span class="group-label-text">{{ page.label }}</span>
                              <v-chip
                                v-if="getGroupAddMode(page) === 'mixed'"
                                size="x-small"
                                color="info"
                                variant="tonal"
                                class="ml-2"
                              >Mixed</v-chip>
                            </div>
                            <v-btn-toggle
                              :model-value="getGroupAddToggleValue(page)"
                              @update:modelValue="v => setGroupAddMode(page, v)"
                              density="compact"
                              variant="outlined"
                              divided
                              class="permission-toggle"
                            >
                              <v-btn value="view" size="x-small" color="amber-darken-3" title="Grant view to all">
                                <v-icon size="14">mdi-eye-outline</v-icon>
                              </v-btn>
                              <v-btn v-if="!isGroupAllViewOnly(page)" value="edit" size="x-small" color="primary" title="Grant full edit (Add/Edit/Delete) to all">
                                <v-icon size="14">mdi-pencil-outline</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                          <!-- Children -->
                          <div class="children-container">
                            <div
                              v-for="child in page.children"
                              :key="child.key"
                              class="permission-row child-row"
                            >
                              <div class="permission-label">
                                <span class="child-label-text">{{ child.label }}</span>
                              </div>
                              <v-btn-toggle
                                :model-value="getAddPermArray(child.key, !!child.accessOnly)"
                                @update:modelValue="v => setAddPermArray(child.key, v, !!child.viewOnly, !!child.accessOnly)"
                                multiple
                                density="compact"
                                variant="outlined"
                                divided
                                class="permission-toggle"
                              >
                                <v-btn value="view" size="x-small" color="amber-darken-3" :title="child.viewOnly ? 'View (read-only page)' : (child.accessOnly ? 'View only — read-only access' : 'View only')">
                                  <v-icon size="14">mdi-eye-outline</v-icon>
                                </v-btn>
                                <template v-if="!child.viewOnly && !child.accessOnly">
                                  <v-btn value="add" size="x-small" color="primary" title="Can add">
                                    <v-icon size="14">mdi-plus</v-icon>
                                  </v-btn>
                                  <v-btn value="edit" size="x-small" color="primary" title="Can edit">
                                    <v-icon size="14">mdi-pencil-outline</v-icon>
                                  </v-btn>
                                  <v-btn value="delete" size="x-small" color="error" title="Can delete">
                                    <v-icon size="14">mdi-delete-outline</v-icon>
                                  </v-btn>
                                </template>
                                <template v-else-if="child.accessOnly">
                                  <v-btn value="access" size="x-small" color="success" title="Full access — can use the page">
                                    <v-icon size="14">mdi-message-check-outline</v-icon>
                                  </v-btn>
                                </template>
                              </v-btn-toggle>
                            </div>
                          </div>
                        </div>
                        <!-- Standalone page -->
                        <div v-else class="permission-row mb-1">
                          <div class="permission-label">
                            <v-icon size="18" color="grey-darken-1" class="mr-2">{{ page.icon || 'mdi-file-outline' }}</v-icon>
                            <span>{{ page.label }}</span>
                          </div>
                          <v-btn-toggle
                            :model-value="getAddPermArray(page.key, !!page.accessOnly)"
                            @update:modelValue="v => setAddPermArray(page.key, v, !!page.viewOnly, !!page.accessOnly)"
                            multiple
                            density="compact"
                            variant="outlined"
                            divided
                            class="permission-toggle"
                          >
                            <v-btn value="view" size="x-small" color="amber-darken-3" :title="page.viewOnly ? 'View (read-only page)' : (page.accessOnly ? 'View only — read-only access' : 'View only')">
                              <v-icon size="14">mdi-eye-outline</v-icon>
                            </v-btn>
                            <template v-if="!page.viewOnly && !page.accessOnly">
                              <v-btn value="add" size="x-small" color="primary" title="Can add">
                                <v-icon size="14">mdi-plus</v-icon>
                              </v-btn>
                              <v-btn value="edit" size="x-small" color="primary" title="Can edit">
                                <v-icon size="14">mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn value="delete" size="x-small" color="error" title="Can delete">
                                <v-icon size="14">mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                            <template v-else-if="page.accessOnly">
                              <v-btn value="access" size="x-small" color="success" title="Full access — can use the page">
                                <v-icon size="14">mdi-message-check-outline</v-icon>
                              </v-btn>
                            </template>
                          </v-btn-toggle>
                        </div>
                      </template>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="closeadd"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon start>mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
              <v-btn
                v-if="canAdd"
                id="button-save-popupadd-usermanagement"
                variant="elevated"
                @click="AddUser"
                class="dialog-action-btn save-btn-add"
              >
                <v-icon start>mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog change password-->
    <v-dialog
      v-model="changPasswordDialog"
      max-width="600px"
      persistent
      z-index="1000"
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-change-password">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background renew-mode">
                <v-icon size="24" color="white">mdi-lock-reset</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Change Password</h2>
              <p class="dialog-subtitle">
                Create a new secure password for your account
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              @click="closeChangePassword"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="change-password-content">
          <v-container fluid>
            <!-- Password Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-lock-outline</v-icon>
                Password Requirements
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">New Password *</label>
                    <v-text-field
                      id="password-field-popupedit-usermanagement"
                      ref="password"
                      v-model="edit.password"
                      :rules="[rules.required]"
                      :type="show3 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter new password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show3 = !show3"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show3 ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements with Animation -->
                    <transition name="slide-fade" mode="out-in">
                      <div
                        class="password-requirements"
                        v-if="edit.password"
                        key="requirements"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLengthPassword }"
                        >
                          <v-icon
                            size="12"
                            :color="checkLengthPassword ? 'success' : 'error'"
                          >
                            {{
                              checkLengthPassword ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checklengthcharacters") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLowercaseLetter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkLowercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkLowercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checklowercaseletter") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkUppercaseLetter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkUppercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkUppercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checkuppercaseletter") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkNumber }"
                        >
                          <v-icon
                            size="12"
                            :color="checkNumber ? 'success' : 'error'"
                          >
                            {{ checkNumber ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          <span>{{ $t("checknumber") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkSpecialCharacter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkSpecialCharacter ? 'success' : 'error'"
                          >
                            {{
                              checkSpecialCharacter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checkspecialcharacter") }}</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Confirm New Password *</label>
                    <v-text-field
                      id="confirmpassword-field-popupedit-usermanagement"
                      ref="confirmpassword"
                      v-model="edit.confirmpassword"
                      :rules="[rules.required]"
                      :type="show4 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Confirm new password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show4 = !show4"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show4 ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator with Animation -->
                    <transition name="slide-fade" mode="out-in">
                      <div
                        class="password-match"
                        v-if="edit.confirmpassword"
                        key="match"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkPasswordMatch }"
                        >
                          <v-icon
                            size="12"
                            :color="checkPasswordMatch ? 'success' : 'error'"
                          >
                            {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          <span>{{ $t("checkpasswordmatch") }}</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
              </v-row>

              <!-- Password Strength Indicator with Animation -->
              <transition name="expand-fade" mode="out-in">
                <v-row class="form-row" v-if="edit.password" key="strength">
                  <v-col cols="12">
                    <div class="password-strength-wrapper">
                      <div class="strength-label">
                        <v-icon
                          size="16"
                          :color="passwordStrength.color"
                          class="mr-1"
                        >
                          {{ passwordStrength.icon }}
                        </v-icon>
                        Password Strength:
                        <span
                          :style="{ color: passwordStrength.color }"
                          class="strength-text"
                        >
                          {{ passwordStrength.text }}
                        </span>
                      </div>
                      <v-progress-linear
                        :model-value="passwordStrength.value"
                        :color="passwordStrength.color"
                        height="6"
                        rounded
                        class="strength-bar"
                      >
                      </v-progress-linear>
                    </div>
                  </v-col>
                </v-row>
              </transition>
            </div>

            <!-- Security Tips -->
            <div class="security-tips">
              <v-alert
                type="info"
                variant="tonal"
                density="compact"
                class="security-alert"
              >
                <template v-slot:prepend>
                  <v-icon>mdi-message-check-outline</v-icon>
                </template>
                <div class="alert-content">
                  <strong>Security Tips:</strong>
                  <ul class="tips-list">
                    <li>Use a unique password that you don't use elsewhere</li>
                    <li>
                      Consider using a passphrase with mixed case, numbers, and
                      symbols
                    </li>
                    <li>
                      Avoid personal information like names, birthdays, or
                      common words
                    </li>
                    <li>Change your password regularly for better security</li>
                  </ul>
                </div>
              </v-alert>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="change-password-actions">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="grey"
            @click="closeChangePassword"
            class="dialog-action-btn cancel-btn"
          >
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
          <v-btn
            id="button-savechangepassword-popupedit-usermanagement"
            variant="elevated"
            @click="saveChangePassword"
            :disabled="!passwordIsValid"
            class="dialog-action-btn save-btn-change-password"
          >
            <v-icon start>mdi-content-save</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Please Wait -->
    <!-- <v-overlay v-model="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="flagTemplate" max-width="900px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon class="header-icon" color="white">mdi-file-download-outline</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Template User</h2>
              <p class="dialog-subtitle">
                Download template files for user import
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
            icon
            variant="text"
            size="small"
            @click="flagTemplate = false"
            class="close-button"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="template-content">
          <div class="template-description">
            <v-alert type="info" variant="tonal" class="mb-4" density="compact">
              <template v-slot:prepend>
                <v-icon>mdi-information-outline</v-icon>
              </template>
              <div class="alert-content">
                <strong>How to use templates:</strong>
                <ul class="template-instructions">
                  <li>Select the appropriate template format for your needs</li>
                  <li>Download the template file</li>
                  <li>
                    Fill in your user data following the template structure
                  </li>
                  <li>Upload the completed file using the import section</li>
                </ul>
              </div>
            </v-alert>
          </div>

          <div class="template-table-wrapper">
            <v-data-table-server
              :items="dataTemplate"
              :headers="enhancedHeadersTemplate"
              loading-text="Loading..."
              hide-default-footer
              disable-sort
              class="template-table"
              density="comfortable"
            >
              <template v-slot:item="{ item }">
                <tr class="template-row">
                  <!-- CSV Column -->
                  <td class="download-cell">
                    <v-btn
                      id="button-downloadtemplate-csv-portaluermanagement"
                      variant="elevated"
                      color="success"
                      size="small"
                      class="download-btn"
                      @click="linkDownload(item.CSV)"
                    >
                      <v-icon start>mdi-file</v-icon>
                      CSV
                      <v-tooltip activator="parent" location="top">
                        Download User - CSV Template
                      </v-tooltip>
                    </v-btn>
                  </td>

                  <!-- Excel Column -->
                  <td class="download-cell">
                    <v-btn
                      id="button-downloadtemplate-excel-portaluermanagement"
                      variant="elevated"
                      color="green"
                      size="small"
                      class="download-btn"
                      @click="linkDownload(item.Excel)"
                    >
                      <v-icon start>mdi-file-excel</v-icon>
                      Excel
                      <v-tooltip activator="parent" location="top">
                        Download User - Excel Template
                      </v-tooltip>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn
            variant="outlined"
            color="grey"
            @click="flagTemplate = false"
            class="dialog-action-btn cancel-btn"
          >
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
            </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import store from "../store";
import ExcelJS from "exceljs";

// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import DragDropFile from "@/components/DragDropFile.vue";
import { kccPickerSource, kccUnavailableReason } from "@/services/kccPickerSource";
export default {
  name: "UserManagement",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile },
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data: () => ({
    mask: "##########",
    show1: false,
    show2: false,
    show3: false,
    show4: false,
    formHasErrors: false,
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    filters: {
      username: [],
      email: [],
      employeeName: [],
      userType: [],
    },
    DDRole: [
      {
        name: "Admin",
        value: 1,
      },
      {
        name: "ผู้ใช้งานทั่วไป",
        value: 2,
      },
    ],
    numberRules: [(v) => !!v || "Input is required!"],
    rules: {
      required: (value) => value === null || !!value || "Required.",
      min: (v) => v.length >= 10 || "Min 10 numbers",
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      password: null,
      confirmpassword: null,
      roleId: null,
      userType: null,
      model: [],
      lockStatus: false,
      vectordbName: [],
      dataIntegrationID: [],
      productGroupID: [],
      intentGroupID:[],
      flowGroupID:[],
      communityGraphID: [],
      metaCommunityGraphID: [],
      metaVectordbName: [],
      isCustomPageAccess: false,
      customPagePermission: []
    },
    user: {
      id: null,
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      password: null,
      confirmpassword: null,
      roleId: 2,
      userType: null,
      model: [],
      lockStatus: false,
      vectordbName: [],
      dataIntegrationID: [],
      productGroupID: [],
      intentGroupID:[],
      flowGroupID:[],
      communityGraphID: [],
      metaCommunityGraphID: [],
      metaVectordbName: [],
      isCustomPageAccess: false,
      customPagePermission: []
    },
    listDDModel: [],
    listDDIntentGroup: [],
    listDDFlowGroup: [],
    listDDProductGroup: [],
    listDDCommunityGraph: [],
    listDDMetaCommunityGraph: [],
    listDDMetaDoc: [],
    // App Knowledge Center (kccPickerSource · A4): kccCenterMode = status.enabled ⇒ Document / Meta Docs เลือกจากเอกสารของ
    // Center เท่านั้น · kcc*Unavailable = ชื่อ i18n เมื่อดึงรายการไม่ได้ ("" = ไม่มีปัญหา)
    kccCenterMode: false,
    kccDocsUnavailable: "",
    kccMetaDocsUnavailable: "",

    oldPassword: "",
    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    username: "",
    email: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    today: null,
    userListDDL: [],
    userList: [],
    headers: [],
    secretKey: "01234567890123456789012345678901",
    roleId: Cookies.get("roleId"),
    currentUserId: Cookies.get("username"),
    isFirst: true,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    accept:
      "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    fileImportUser: null,
    flagTemplate: false,
    dataTemplate: [
      {
        CSV: "CSV",
        Excel: "Excel",
      },
    ],
    checkLengthPassword: true,
    checkLowercaseLetter: true,
    checkUppercaseLetter: true,
    checkNumber: true,
    checkSpecialCharacter: true,
    checkPasswordMatch: true,
    statusFormatPassword: false,
    statusPassword: false,
    flagChangePassword: false,
    changPasswordDialog: false,

    // Page definitions per role for Custom Page Access
    // `viewOnly: true`   = read-only page; only the View eye is offered (no Edit pencil).
    // `accessOnly: true` = page has no Add/Edit/Delete actions inside; permission is just
    //                       view-only access vs full access (binary toggle).
    // `adminOnly: true`  = API ของหน้านี้เปิดให้แค่ role 0/1 (ดู APIAuthen.cs) — ซ่อนตอนตั้งสิทธิ์ให้ User (2)
    //                       ไม่งั้นเขาจะเปิดหน้าได้แต่เรียก API ไม่ผ่านสักเส้น
    // เมนูที่ไม่มีในนี้โดยตั้งใจ: SocialApiLog / JobLog (API เปิดแค่ Super admin) และกลุ่ม Tax Planning V1
    // (ปิดอยู่ใน menuClosure — มี V2 แทนแล้ว)
    adminAvailablePages: [
      { key: 'dashboard', label: 'Dashboard', icon: 'mdi-view-dashboard', viewOnly: true },
      { key: 'GPTModelManagement', label: 'Model Creator', icon: 'mdi-file-document' },
      { key: 'Vector', label: 'Knowledge Management', icon: 'mdi-cloud-upload', isGroup: true, children: [
        { key: 'VectorManagement', label: 'Documents' },
        { key: 'MetaDoc', label: 'MetaDoc' },
        { key: 'DataIntegration', label: 'Database Integration' },
        { key: 'MutualFund', label: 'Mutual Fund' },
        { key: 'ProductGroup', label: 'Products' },
        { key: 'UploadSoundToDocument', label: 'Upload Sound To Document' },
        { key: 'CommunityManagement', label: 'Community Management' },
        { key: 'MetaCommunityManagement', label: 'Meta Community' },
        { key: 'GenerationErrorLogs', label: 'Generation Error Logs', viewOnly: true },
      ]},
      { key: 'FlowList', label: 'Flow', icon: 'mdi-chart-timeline-variant-shimmer' },
      { key: 'ToolManagement', label: 'Tool Management', icon: 'mdi-robot-industrial' },
      { key: 'IntentGroup', label: 'Intent', icon: 'mdi-comment-processing-outline' },
      { key: 'LHBankConfig', label: 'LH Bank Configuration', icon: 'mdi-bank', isGroup: true, children: [
        { key: 'LHBDashboard', label: 'Dashboard', viewOnly: true },
        { key: 'AccountInfoManagement', label: 'Account Info' },
        { key: 'LoanInterestRate', label: 'Loan Interest Rate' },
        { key: 'ProactiveMessage', label: 'Proactive Messages' },
        { key: 'BarManagement', label: 'Bar Management' },
        { key: 'DeepLinkConfig', label: 'Deep Link Configuration' },
        { key: 'AccessLevelConfig', label: 'Access Level Configuration' },
        { key: 'MobileConfigurations', label: 'Mobile Configurations' },
        { key: 'LexiconManagement', label: 'Lexicon Management' },
        { key: 'TargetPhraseManagement', label: 'Target Phrases' },
        { key: 'VoiceConfigs', label: 'Voice Configs' },
        { key: 'ChatFullLogs', label: 'Chat Full Logs', viewOnly: true },
        { key: 'CifZeroInitLog', label: 'CIF Zero Init Log', viewOnly: true },
      ]},
      { key: 'Replace', label: 'Optimization Techniques', icon: 'mdi-find-replace', isGroup: true, children: [
        { key: 'GroupPromptTemplate', label: 'Prompt Template' },
        { key: 'GroupReplacetext', label: 'Text Replacement' },
      ]},
      { key: 'QAConsole', label: 'QA Console', icon: 'mdi-shield-check', isGroup: true, children: [
        { key: 'QAOverview', label: 'Team Overview', viewOnly: true },
        { key: 'QAAgents', label: 'Agents', viewOnly: true },
        { key: 'QACases', label: 'Case Explorer', viewOnly: true },
        { key: 'QAInvestigations', label: 'Investigations' },
        { key: 'QASettings', label: 'QA Settings' },
        { key: 'QAJobs', label: 'Background Jobs', viewOnly: true, adminOnly: true },
      ]},
      { key: 'Validation', label: 'Model Testing', icon: 'mdi-folder', isGroup: true, children: [
        { key: 'ValidationGenerate', label: 'Generate Test Questions' },
        { key: 'ValidationPositive', label: 'Positive Question Set' },
        { key: 'ValidationNegative', label: 'Negative Question Set' },
        { key: 'ValidationProcess', label: 'Execute Test Runs' },
      ]},
      { key: 'User', label: 'User Management', icon: 'mdi-account-multiple', isGroup: true, children: [
        { key: 'UserManagement', label: 'Portal User Management' },
        { key: 'UserChatManagement', label: 'Chat User Management' },
        { key: 'GroupUserManagement', label: 'User Group' },
        { key: 'BlacklistChatUserManagement', label: 'Blacklist Chat User' },
      ]},
      { key: 'ChatManagement', label: 'Chat Management', icon: 'mdi-message-settings', isGroup: true, children: [
        { key: 'SetupGroupModel', label: 'Model Grouping' },
        { key: 'ModelShortcut', label: 'Model Shortcut' },
        { key: 'ModelQuickReply', label: 'Model Quick Reply' },
        { key: 'ShortcutMenu', label: 'Shortcut Menu' },
      ]},
      { key: 'Setting', label: 'Setting', icon: 'mdi-wrench', isGroup: true, children: [
        { key: 'Setup', label: 'Core Configurations' },
        { key: 'SettingExternalConnector', label: 'External Connector' },
        { key: 'McpConnection', label: 'MCP Connection', adminOnly: true },
        { key: 'ModelData', label: 'LLMs Management' },
        { key: 'SetupSocial', label: 'Platform Integration' },
        { key: 'ServiceTheme', label: 'Service Theme' },
        { key: 'ConsentConfig', label: 'Consent Config' },
      ]},
      { key: 'TaxPlanningV2', label: 'Tax Planning V2', icon: 'mdi-calculator-variant-outline', isGroup: true, children: [
        { key: 'TaxDashboard', label: 'Tax Dashboard', viewOnly: true },
        { key: 'TaxConfigurationV2', label: 'Tax Configuration V2' },
        { key: 'TaxPlaygroundV2', label: 'Tax Playground V2', accessOnly: true },
        { key: 'TaxFeedbackSettings', label: 'Tax Feedback Reasons' },
        { key: 'TaxLogV2', label: 'Tax Log', viewOnly: true },
        // Chat Logs ในโหมดภาษี (TaxChatLog.vue ห่อ LogMessage.vue) — อ่านอย่างเดียว แยกสิทธิ์จาก Chat Logs ในกลุ่ม Logs
        { key: 'TaxChatLog', label: 'Tax Chat Log', viewOnly: true },
        { key: 'TaxHistoryV2', label: 'Tax History V2', viewOnly: true },
        { key: 'TaxPlanningMobileConfigurations', label: 'Mobile Configurations' },
        { key: 'TaxConsent', label: 'Tax Consent' },
        // ใช้คุมสิทธิ์แทนขั้นขออนุมัติบนหน้า Decrypt — ติ๊กตาเปิดให้ใช้ได้ทั้ง Encrypt และ Decrypt
        { key: 'DecryptTax', label: 'Tax CIF Encrypt / Decrypt', viewOnly: true },
      ]},
      { key: 'Report', label: 'Reports', icon: 'mdi-chart-box-multiple', isGroup: true, children: [
        { key: 'ReportQuestionTop10', label: 'Question Trends', viewOnly: true },
        { key: 'ReportUserTop10', label: 'Top Users', viewOnly: true },
        { key: 'ReportUserUse', label: 'Total Usage Insights', viewOnly: true },
        { key: 'ReportTokenSum', label: 'Token Summation', viewOnly: true },
        { key: 'ReportFeedback', label: 'Feedback', viewOnly: true },
      ]},
      { key: 'Logs', label: 'Logs', icon: 'mdi-clipboard-text', isGroup: true, children: [
        { key: 'LogMessage', label: 'Chat Logs', viewOnly: true },
        { key: 'ContactAgentChatLog', label: 'Contact Agent Chat Log', viewOnly: true },
        { key: 'LogEvent', label: 'Log Event', viewOnly: true },
        { key: 'LogAPIExternal', label: 'API External Log', viewOnly: true },
      ]},
      { key: 'Stream', label: 'Chat Playground', icon: 'mdi-monitor', accessOnly: true },
      { key: 'Playground', label: 'Dual Chat Playground', icon: 'mdi-monitor-multiple', accessOnly: true },
      { key: 'ChatService', label: 'Chat Service', icon: 'mdi-forum', accessOnly: true },
    ],
    // NOTE: userAvailablePages removed (CR 2026-05-13) — User role (RoleId=2) now uses
    // adminAvailablePages to expose all Super Admin menus in the Custom Page Access picker.
    operatorAvailablePages: [
      { key: 'dashboard', label: 'Dashboard', icon: 'mdi-view-dashboard', viewOnly: true },
      { key: 'ChatService', label: 'Chat Service', icon: 'mdi-forum', accessOnly: true },
      { key: 'ChatFullLogs', label: 'Chat Full Logs', icon: 'mdi-volume-high', viewOnly: true },
    ],
  }),
  watch: {
    
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    "user.password"() {
      let self = this;
      if (
        self.user.password != null &&
        self.user.password != undefined &&
        self.user.password != ""
      ) {
        self.checkLengthPassword = self.user.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.user.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.user.password);
        self.checkNumber = /\d/.test(self.user.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.user.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.user.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }

        if (self.user.password == self.user.confirmpassword) {
          self.checkPasswordMatch = true;
        }
        if (
          self.user.confirmpassword != null &&
          self.user.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "user.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.user.password == self.user.confirmpassword;
      if (
        self.user.password == self.user.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
    "edit.roleId"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.edit.customPagePermission = [];
        this.edit.isCustomPageAccess = false;
      }
    },
    "user.roleId"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.user.customPagePermission = [];
        this.user.isCustomPageAccess = false;
      }
    },
    "edit.password"() {
      let self = this;
      if (
        self.edit.password != null &&
        self.edit.password != undefined &&
        self.edit.password != ""
      ) {
        self.checkLengthPassword = self.edit.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.edit.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.edit.password);
        self.checkNumber = /\d/.test(self.edit.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.edit.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.edit.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }
        if (self.edit.password == self.edit.confirmpassword) {
          self.checkPasswordMatch = true;
        } else if (
          self.edit.confirmpassword != null &&
          self.edit.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "edit.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.edit.password == self.edit.confirmpassword;
      if (
        self.edit.password == self.edit.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
  },
  mounted() {
    // this.permission = this.checkPermissionFour(1, 2, 3, 4);
    this.headers = [
      {
        title: this.$t("no"),
        align: "center",
        sortable: false,
      },
      {
        title: this.$t("username"),
        align: "center",
        sortable: true,
        value: "username",
      },
      {
        title: this.$t("email"),
        align: "center",
        sortable: true,
        value: "email",
      },
      {
        title: this.$t("phonenumber"),
        align: "center",
        sortable: true,
        value: "mobile",
      },
      { title: "Name", align: "center", sortable: true, value: "fullName" },
      {
        title: this.$t("action"),
        align: "center",
        sortable: false,
        width: "150px",
      },
    ];
    this.GetDate();
    this.GetModel();
    this.GetDDIntentGroupName();
    this.GetDDProductGroupList();
    this.GetDDdataIntegration();
    this.GetDDVectorDBNameManagement();
    this.GetDDFlowGroup();
    this.GetDDCommunityGraph();
    this.GetDDMetaCommunityGraph();
    this.GetDDMetaDoc();
  },
  computed: {
    // filterListDDModel() {
    //   const data = this.listDDModel.filter((item, index, array) => {
    //     return array.findIndex(obj => obj.modelDisplayID === item.modelDisplayID) === index;
    //   });
    //   return data
    // },
    filteredUsers() {
      return this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    form() {
      return {
        username: this.user.username,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        email: this.user.email,
        phone: this.user.phone,
        password: this.user.password,
        confirmpassword: this.user.confirmpassword,
      };
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
    enhancedHeadersTemplate() {
      return [
        {
          title: "CSV",
          key: "csv",
          align: "center",
          width: "50%",
          sortable: false,
        },
        {
          title: "Excel",
          key: "excel",
          align: "center",
          width: "50%",
          sortable: false,
        },
      ];
    },
    passwordStrength() {
      if (!this.edit.password)
        return {
          value: 0,
          color: "grey",
          text: "No password",
          icon: "mdi-minus",
        };

      let score = 0;
      let feedback = [];

      // Length check
      if (this.edit.password.length >= 8) score += 20;
      else feedback.push("Use at least 8 characters");

      // Character variety checks
      if (/[a-z]/.test(this.edit.password)) score += 15;
      else feedback.push("Add lowercase letters");

      if (/[A-Z]/.test(this.edit.password)) score += 15;
      else feedback.push("Add uppercase letters");

      if (/\d/.test(this.edit.password)) score += 15;
      else feedback.push("Add numbers");

      if (/[^a-zA-Z0-9ก-๙]/.test(this.edit.password)) score += 15;
      else feedback.push("Add special characters");

      // Additional complexity
      if (this.edit.password.length >= 12) score += 10;
      if (this.edit.password.length >= 16) score += 10;

      if (score <= 30) {
        return {
          value: score,
          color: "error",
          text: "Weak",
          icon: "mdi-shield-alert",
        };
      } else if (score <= 60) {
        return {
          value: score,
          color: "warning",
          text: "Fair",
          icon: "mdi-shield-half-full",
        };
      } else if (score <= 80) {
        return {
          value: score,
          color: "info",
          text: "Good",
          icon: "mdi-shield-check",
        };
      } else {
        return {
          value: score,
          color: "success",
          text: "Strong",
          icon: "mdi-message-check-outline",
        };
      }
    },
    passwordIsValid() {
      return (
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter &&
        this.checkPasswordMatch &&
        this.edit.password &&
        this.edit.confirmpassword
      );
    },

    // --- Custom Page Access computed ---
    // Admin (1) และ User (2) ใช้ catalog เดียวกัน (= adminAvailablePages = ครบ Super Admin NavBar)
    // เพื่อให้ admin สามารถ grant สิทธิ์เข้าทุกเมนูให้ User ได้ตาม CR — ยกเว้นหน้า adminOnly ที่ User ใช้ API ไม่ได้
    editAvailablePagesForRole() {
      return this.availablePagesForRole(this.edit.roleId);
    },
    addAvailablePagesForRole() {
      return this.availablePagesForRole(this.user.roleId);
    },
    editPermissionMap() {
      const map = Object.create(null);
      for (const item of this.edit.customPagePermission || []) {
        if (item && item.key) map[item.key] = item;
      }
      return map;
    },
    addPermissionMap() {
      const map = Object.create(null);
      for (const item of this.user.customPagePermission || []) {
        if (item && item.key) map[item.key] = item;
      }
      return map;
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('UserManagement');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('UserManagement'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('UserManagement'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('UserManagement'));
    },
  },

  methods: {

    // --- Custom Page Access helper methods ---
    availablePagesForRole(roleId) {
      if (roleId === 1) return this.adminAvailablePages;
      if (roleId === 2) return this.withoutAdminOnlyPages(this.adminAvailablePages);
      if (roleId === 6) return this.operatorAvailablePages;
      return [];
    },
    // ตัดหน้าที่ flag adminOnly ออก และตัดกลุ่มที่ไม่เหลือหน้าลูก
    withoutAdminOnlyPages(pages) {
      const out = [];
      for (const page of pages) {
        if (page.adminOnly) continue;
        if (page.isGroup && page.children) {
          const children = page.children.filter(c => !c.adminOnly);
          if (children.length) out.push({ ...page, children });
        } else {
          out.push(page);
        }
      }
      return out;
    },
    getAllPageKeys(pages) {
      let keys = [];
      for (const page of pages) {
        if (page.isGroup && page.children) {
          keys.push(...page.children.map(c => c.key));
        } else {
          keys.push(page.key);
        }
      }
      return keys;
    },
    // Reorder permission list to match nav order.
    sortPermissionByNavOrder(permissions, availablePages) {
      const orderedKeys = this.getAllPageKeys(availablePages);
      return [...permissions].sort((a, b) => {
        const keyA = typeof a === 'string' ? a : (a && a.key);
        const keyB = typeof b === 'string' ? b : (b && b.key);
        const indexA = orderedKeys.indexOf(keyA);
        const indexB = orderedKeys.indexOf(keyB);
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      });
    },

    // Build the granular action map from a raw value. Missing/invalid input defaults to all-true
    // (legacy "edit" without explicit actions represents full access).
    normalizeActions(raw) {
      if (raw && typeof raw === 'object') {
        return {
          add: raw.add !== false,
          edit: raw.edit !== false,
          delete: raw.delete !== false,
        };
      }
      return { add: true, edit: true, delete: true };
    },
    fullAccessActions() {
      return { add: true, edit: true, delete: true };
    },
    noActions() {
      return { add: false, edit: false, delete: false };
    },
    // Normalize legacy string[] or mixed input into [{key, mode, actions}]. Unknown modes default
    // to 'edit'. Any page flagged viewOnly in the catalog is coerced to mode 'view' so legacy
    // records can't grant edit on read-only pages. Pages flagged accessOnly that end up in
    // mode='edit' are forced to fullAccess actions so the binary toggle stays consistent.
    normalizePermissionList(raw) {
      if (!Array.isArray(raw)) return [];
      const viewOnlyKeys = this.getViewOnlyKeys();
      const accessOnlyKeys = this.getAccessOnlyKeys();
      const out = [];
      for (const item of raw) {
        if (typeof item === 'string' && item) {
          if (viewOnlyKeys.has(item)) {
            out.push({ key: item, mode: 'view', actions: this.noActions() });
          } else {
            out.push({ key: item, mode: 'edit', actions: this.fullAccessActions() });
          }
        } else if (item && typeof item === 'object' && typeof item.key === 'string' && item.key) {
          let mode = item.mode === 'view' ? 'view' : 'edit';
          if (mode === 'edit' && viewOnlyKeys.has(item.key)) mode = 'view';
          let actions;
          if (mode === 'view') {
            actions = this.noActions();
          } else if (accessOnlyKeys.has(item.key)) {
            // Access-only pages have no granular actions — full access is the only edit state.
            actions = this.fullAccessActions();
          } else {
            actions = this.normalizeActions(item.actions);
          }
          out.push({ key: item.key, mode, actions });
        }
      }
      return out;
    },
    // Flatten all role catalogs and collect keys flagged viewOnly.
    getViewOnlyKeys() {
      const keys = new Set();
      const walk = (pages) => {
        for (const page of pages || []) {
          if (page.isGroup && page.children) {
            for (const child of page.children) {
              if (child.viewOnly) keys.add(child.key);
            }
          } else if (page.viewOnly) {
            keys.add(page.key);
          }
        }
      };
      walk(this.adminAvailablePages);
      walk(this.operatorAvailablePages);
      return keys;
    },
    // Flatten all role catalogs and collect keys flagged accessOnly.
    getAccessOnlyKeys() {
      const keys = new Set();
      const walk = (pages) => {
        for (const page of pages || []) {
          if (page.isGroup && page.children) {
            for (const child of page.children) {
              if (child.accessOnly) keys.add(child.key);
            }
          } else if (page.accessOnly) {
            keys.add(page.key);
          }
        }
      };
      walk(this.adminAvailablePages);
      walk(this.operatorAvailablePages);
      return keys;
    },
    isAccessOnlyKey(key) {
      return this.getAccessOnlyKeys().has(key);
    },

    // Look up a page key in the available tree and return its definition (or null).
    findPageDefinition(key, pages) {
      for (const page of pages || []) {
        if (page.isGroup && page.children) {
          for (const child of page.children) {
            if (child.key === key) return child;
          }
        } else if (page.key === key) {
          return page;
        }
      }
      return null;
    },
    // --- Permission record helpers ---
    // Build the per-row v-btn-toggle model array (e.g., ['view'] or ['add','edit']).
    // For access-only pages, mode='edit' (full access) collapses to a single ['access'] token
    // because there are no granular Add/Edit/Delete actions to expose.
    permRecordToArray(record, isAccessOnly = false) {
      if (!record) return [];
      if (record.mode === 'view') return ['view'];
      if (record.mode === 'edit') {
        if (isAccessOnly) return ['access'];
        const a = this.normalizeActions(record.actions);
        const arr = [];
        if (a.add) arr.push('add');
        if (a.edit) arr.push('edit');
        if (a.delete) arr.push('delete');
        return arr;
      }
      return [];
    },
    // Reconcile a v-btn-toggle multiple-select array into a stored permission record.
    // - View is mutually exclusive with Add/Edit/Delete: clicking View clears actions; clicking
    //   any action clears View. The reconciliation infers which side the user just clicked by
    //   comparing against the prior state.
    // - Read-only pages can only ever be 'view' or absent.
    // - Returns null when the entry should be removed (no permission).
    reconcilePermArray(prior, nextArr, isReadOnly, isAccessOnly = false) {
      const next = Array.isArray(nextArr) ? [...nextArr] : [];
      const priorMode = prior ? prior.mode : 'none';

      if (isReadOnly) {
        return next.includes('view')
          ? { mode: 'view', actions: this.noActions() }
          : null;
      }

      // Access-only pages: only 'view' or 'access' are valid; 'access' grants full edit.
      if (isAccessOnly) {
        const wantsView = next.includes('view');
        const wantsAccess = next.includes('access');
        let finalMode;
        if (wantsView && wantsAccess) {
          // Both selected — drop whichever wasn't in the prior state.
          finalMode = priorMode === 'view' ? 'access' : 'view';
        } else if (wantsView) {
          finalMode = 'view';
        } else if (wantsAccess) {
          finalMode = 'access';
        } else {
          return null;
        }
        if (finalMode === 'view') return { mode: 'view', actions: this.noActions() };
        return { mode: 'edit', actions: this.fullAccessActions() };
      }

      const wantsView = next.includes('view');
      const wantsActions = next.filter(v => v !== 'view');

      let finalView = false;
      let finalActions = wantsActions;
      if (wantsView && wantsActions.length > 0) {
        // View toggled together with actions — drop whichever side wasn't in the prior state.
        if (priorMode === 'view') {
          finalView = false;
        } else {
          finalView = true;
          finalActions = [];
        }
      } else {
        finalView = wantsView;
        finalActions = wantsActions;
      }

      if (finalView) {
        return { mode: 'view', actions: this.noActions() };
      }
      if (finalActions.length === 0) {
        return null;
      }
      return {
        mode: 'edit',
        actions: {
          add: finalActions.includes('add'),
          edit: finalActions.includes('edit'),
          delete: finalActions.includes('delete'),
        },
      };
    },

    // --- Edit popup: per-page accessors ---
    getEditMode(key) {
      const item = this.editPermissionMap[key];
      return item ? item.mode : 'none';
    },
    getEditPermArray(key, isAccessOnly = false) {
      return this.permRecordToArray(this.editPermissionMap[key], isAccessOnly);
    },
    // Returns true when this page row is in fully granted edit mode (all 3 actions on).
    isEditFullAccess(key) {
      const item = this.editPermissionMap[key];
      if (!item || item.mode !== 'edit') return false;
      const a = this.normalizeActions(item.actions);
      return a.add && a.edit && a.delete;
    },
    setEditPermArray(key, nextArr, isReadOnly, isAccessOnly = false) {
      const list = [...this.edit.customPagePermission];
      const idx = list.findIndex(p => p && p.key === key);
      const prior = idx !== -1 ? list[idx] : null;
      const reconciled = this.reconcilePermArray(prior, nextArr, isReadOnly, isAccessOnly);
      if (reconciled === null) {
        if (idx !== -1) list.splice(idx, 1);
      } else {
        const entry = { key, mode: reconciled.mode, actions: reconciled.actions };
        if (idx !== -1) list[idx] = entry;
        else list.push(entry);
      }
      this.edit.customPagePermission = list;
    },
    bulkSetEditMode(mode) {
      const pages = this.editAvailablePagesForRole;
      const allKeys = this.getAllPageKeys(pages);
      if (!mode || mode === 'none') {
        this.edit.customPagePermission = [];
        return;
      }
      this.edit.customPagePermission = allKeys.map(k => {
        const def = this.findPageDefinition(k, pages);
        const isReadOnly = !!(def && def.viewOnly);
        if (isReadOnly || mode === 'view') {
          return { key: k, mode: 'view', actions: this.noActions() };
        }
        // mode === 'edit' on a writable page → full access (all actions).
        // accessOnly pages also collapse to mode='edit' with full actions for "All Edit".
        return { key: k, mode: 'edit', actions: this.fullAccessActions() };
      });
    },
    // Group-level state. Returns 'none' | 'view' | 'edit-full' | 'mixed'.
    // 'edit-full' means every non-viewOnly child has all 3 actions on, and every viewOnly child
    // is set to view — i.e., the group is uniformly granted full edit. accessOnly children are
    // considered "edit-full" when their mode is 'edit' (full access). Anything else is 'mixed'.
    getGroupEditMode(group) {
      const records = group.children.map(c => ({ child: c, item: this.editPermissionMap[c.key] }));
      if (records.every(r => !r.item)) return 'none';
      if (records.every(r => r.item && r.item.mode === 'view')) return 'view';
      const editFull = records.every(r => {
        if (!r.item) return false;
        if (r.child.viewOnly) return r.item.mode === 'view';
        if (r.item.mode !== 'edit') return false;
        if (r.child.accessOnly) return true;
        const a = this.normalizeActions(r.item.actions);
        return a.add && a.edit && a.delete;
      });
      if (editFull) return 'edit-full';
      return 'mixed';
    },
    getGroupEditToggleValue(group) {
      const mode = this.getGroupEditMode(group);
      if (mode === 'view') return 'view';
      if (mode === 'edit-full') return 'edit';
      return null;
    },
    // Group "Edit" applies full access (Add/Edit/Delete) to non-viewOnly children; viewOnly
    // children are forced to 'view'.
    setGroupEditMode(group, mode) {
      const childKeys = new Set(group.children.map(c => c.key));
      const kept = this.edit.customPagePermission.filter(p => p && !childKeys.has(p.key));
      if (mode === 'view') {
        for (const c of group.children) {
          kept.push({ key: c.key, mode: 'view', actions: this.noActions() });
        }
      } else if (mode === 'edit') {
        for (const c of group.children) {
          if (c.viewOnly) {
            kept.push({ key: c.key, mode: 'view', actions: this.noActions() });
          } else {
            kept.push({ key: c.key, mode: 'edit', actions: this.fullAccessActions() });
          }
        }
      }
      this.edit.customPagePermission = kept;
    },
    // True when every child is flagged viewOnly — used to hide the group's "Edit" icon entirely.
    isGroupAllViewOnly(group) {
      return (group.children || []).every(c => !!c.viewOnly);
    },

    // --- Add popup: per-page accessors ---
    getAddMode(key) {
      const item = this.addPermissionMap[key];
      return item ? item.mode : 'none';
    },
    getAddPermArray(key, isAccessOnly = false) {
      return this.permRecordToArray(this.addPermissionMap[key], isAccessOnly);
    },
    setAddPermArray(key, nextArr, isReadOnly, isAccessOnly = false) {
      const list = [...this.user.customPagePermission];
      const idx = list.findIndex(p => p && p.key === key);
      const prior = idx !== -1 ? list[idx] : null;
      const reconciled = this.reconcilePermArray(prior, nextArr, isReadOnly, isAccessOnly);
      if (reconciled === null) {
        if (idx !== -1) list.splice(idx, 1);
      } else {
        const entry = { key, mode: reconciled.mode, actions: reconciled.actions };
        if (idx !== -1) list[idx] = entry;
        else list.push(entry);
      }
      this.user.customPagePermission = list;
    },
    bulkSetAddMode(mode) {
      const pages = this.addAvailablePagesForRole;
      const allKeys = this.getAllPageKeys(pages);
      if (!mode || mode === 'none') {
        this.user.customPagePermission = [];
        return;
      }
      this.user.customPagePermission = allKeys.map(k => {
        const def = this.findPageDefinition(k, pages);
        const isReadOnly = !!(def && def.viewOnly);
        if (isReadOnly || mode === 'view') {
          return { key: k, mode: 'view', actions: this.noActions() };
        }
        return { key: k, mode: 'edit', actions: this.fullAccessActions() };
      });
    },
    getGroupAddMode(group) {
      const records = group.children.map(c => ({ child: c, item: this.addPermissionMap[c.key] }));
      if (records.every(r => !r.item)) return 'none';
      if (records.every(r => r.item && r.item.mode === 'view')) return 'view';
      const editFull = records.every(r => {
        if (!r.item) return false;
        if (r.child.viewOnly) return r.item.mode === 'view';
        if (r.item.mode !== 'edit') return false;
        if (r.child.accessOnly) return true;
        const a = this.normalizeActions(r.item.actions);
        return a.add && a.edit && a.delete;
      });
      if (editFull) return 'edit-full';
      return 'mixed';
    },
    getGroupAddToggleValue(group) {
      const mode = this.getGroupAddMode(group);
      if (mode === 'view') return 'view';
      if (mode === 'edit-full') return 'edit';
      return null;
    },
    setGroupAddMode(group, mode) {
      const childKeys = new Set(group.children.map(c => c.key));
      const kept = this.user.customPagePermission.filter(p => p && !childKeys.has(p.key));
      if (mode === 'view') {
        for (const c of group.children) {
          kept.push({ key: c.key, mode: 'view', actions: this.noActions() });
        }
      } else if (mode === 'edit') {
        for (const c of group.children) {
          if (c.viewOnly) {
            kept.push({ key: c.key, mode: 'view', actions: this.noActions() });
          } else {
            kept.push({ key: c.key, mode: 'edit', actions: this.fullAccessActions() });
          }
        }
      }
      this.user.customPagePermission = kept;
    },

    async GetDDVectorDBNameManagement(){
      // App Knowledge Center (TASK 2026-10-28 G10 · AC-9 · A4/A19): โหมด Center ⇒ catalog ของ Runtime key เท่านั้น (อาจว่าง
      // + ข้อความ — ไม่ถอยไปของในเครื่อง) · โหมดปิด (null) ⇒ $call เดิม · kccPickerSource ไม่ throw
      const kccList = await kccPickerSource.vectorList();
      this.kccCenterMode = kccList !== null;
      if (kccList !== null) {
        this.listDDDocument = kccList;
        this.kccDocsUnavailable = kccUnavailableReason(kccList);
        return;
      }
      this.kccDocsUnavailable = "";
      this.$call.GetDDVectorDBNameManagement(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDDocument = dataResponse.data;
          } else {
            this.listDDDocument = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },

    async GetDDdataIntegration(){
      await this.$call.GetDDdataintegration(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDDataIntegration = dataResponse.data;
          } else {
            this.listDDDataIntegration = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },

    async GetDDProductGroupList(){
      await this.$call.GetDDProductGroupList(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDProductGroup = dataResponse.data
          }else {
            this.listDDProductGroup = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },
    async GetDDIntentGroupName(){
      await this.$call.DDIntentGroup(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDIntentGroup = dataResponse.data;
          } else {
            this.listDDIntentGroup = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },
    async GetDDFlowGroup(){
      await this.$call.GetFlowDropdown(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDFlowGroup = dataResponse.data;
          } else {
            this.listDDFlowGroup = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },
    async GetDDCommunityGraph() {
      await this.$call.GetCommunityDropdown(
        (dataResponse) => {
          this.listDDCommunityGraph = (dataResponse && dataResponse.data) ? dataResponse.data : [];
        },
        (errorResource) => {
          this.listDDCommunityGraph = [];
          console.error(errorResource);
        }
      );
    },
    async GetDDMetaCommunityGraph() {
      await this.$call.GetMetaCommunityDropdown(
        (dataResponse) => {
          this.listDDMetaCommunityGraph = (dataResponse && dataResponse.data) ? dataResponse.data : [];
        },
        (errorResource) => {
          this.listDDMetaCommunityGraph = [];
          console.error(errorResource);
        }
      );
    },
    async GetDDMetaDoc() {
      // App Knowledge Center (G10 · AC-9 · A4): โหมด Center ⇒ catalog ของ Center รูปเดียวกับ GetMetaAvailableDocuments
      // (อาจว่าง + ข้อความ) · โหมดปิด (null) ⇒ $call เดิม
      const kccList = await kccPickerSource.availableMetaDocuments();
      this.kccCenterMode = kccList !== null;
      if (kccList !== null) {
        this.listDDMetaDoc = kccList;
        this.kccMetaDocsUnavailable = kccUnavailableReason(kccList);
        return;
      }
      this.kccMetaDocsUnavailable = "";
      await this.$call.GetMetaAvailableDocuments(
        (dataResponse) => {
          this.listDDMetaDoc = (dataResponse && dataResponse.data) ? dataResponse.data : [];
        },
        (errorResource) => {
          this.listDDMetaDoc = [];
          console.error(errorResource);
        }
      );
    },
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:

      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (
        this.$refs.fileUploader &&
        typeof this.$refs.fileUploader.openFileDialog === "function"
      ) {
        this.$refs.fileUploader.openFileDialog();
      }
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput =
          this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    processUpload(e) {
      let self = this;
      if (e.length > 0) {
        self.fileImportUser = e[0];
        const fileType = self.fileImportUser.name
          .split(".")
          .pop()
          .toLowerCase();

        if (fileType === "xlsx" || fileType === "xls") {
          const reader = new FileReader();
          reader.onload = async (event) => {
            const buffer = event.target.result;
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(buffer);

            const worksheet = workbook.getWorksheet(1);
            if (!worksheet) {
              self.$swal.fire({
                icon: "error",
                title: "No worksheet found in the Excel file",
                showConfirmButton: false,
                timer: 2500,
                zIndex: 9999,
              });
              return;
            }

            // Convert ExcelJS format to JSON object with headers
            const jsonData = [];
            const headers = [];

            // Extract headers from first row
            worksheet.getRow(1).eachCell((cell) => {
              headers.push(cell.value);
            });

            // Process data rows
            worksheet.eachRow((row, rowNumber) => {
              if (rowNumber === 1) return; // Skip header row

              const rowData = {};
              row.eachCell((cell, colNumber) => {
                rowData[headers[colNumber - 1]] = cell.value;
              });

              jsonData.push(rowData);
            });

            self.validateData(jsonData);
          };
          reader.readAsArrayBuffer(self.fileImportUser);
        } else if (fileType === "csv") {
          const reader = new FileReader();
          reader.onload = (event) => {
            const text = event.target.result;
            const rows = text.split("\n").map((row) => row.split(","));
            const headers = rows[0].map((header) => header.trim());
            const jsonData = rows
              .slice(1)
              .map((row) => {
                const obj = {};
                row.forEach((cell, index) => {
                  obj[headers[index]] = cell.trim();
                });
                return obj;
              })
              .filter((row) => Object.keys(row).length > 0);

            self.validateData(jsonData);
          };
          reader.readAsText(self.fileImportUser);
        } else {
          alert(
            "Invalid file type. Please upload an Excel (.xlsx) or CSV (.csv) file."
          );
        }
      }
    },
    validateData(data) {
      let self = this;
      const requiredColumns = ["User Name", "Email"];
      const missingColumns = requiredColumns.filter(
        (col) => !Object.keys(data[0] || {}).includes(col)
      );
      if (missingColumns.length > 0) {
        self.$swal.fire({
          icon: "warning",
          title: "Missing Columns",
          text: `The following required columns are missing: ${missingColumns.join(", ")}`,
          showConfirmButton: true,
        });
        return;
      }

      const usernames = data
        .map((row) => row["User Name"]?.trim())
        .filter(Boolean);
      const emails = data.map((row) => row["Email"]?.trim()).filter(Boolean);

      const duplicateUsernames = usernames.filter(
        (value, index, self) => self.indexOf(value) !== index
      );
      const duplicateEmails = emails.filter(
        (value, index, self) => self.indexOf(value) !== index
      );

      if (duplicateUsernames.length > 0 || duplicateEmails.length > 0) {
        let errorMessage = "";
        if (duplicateUsernames.length > 0) {
          errorMessage += `Duplicate usernames</br> - ${[
            ...new Set(duplicateUsernames),
          ].join(", ")}</br>`;
        }
        if (duplicateEmails.length > 0) {
          errorMessage += `Duplicate emails</br> - ${[
            ...new Set(duplicateEmails),
          ].join(", ")}</br>`;
        }
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          html: `${errorMessage}`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        self.ConfirmProcess();
      }
    },

    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("importUserTitle"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.ImportUser();
          }
        });
    },

    async ImportUser() {
      let self = this;
      self.dialog = true;
      const formDataDoc = new FormData();
      formDataDoc.append("entity", self.fileImportUser);

      var requestUser = {
        entity: formDataDoc,
        isUserChat: false,
      };

      await self.$call.ImportUser(
        requestUser,
        null,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.mesDupUser.length > 0 ||
              dataResponse.data.mesDupEmail.length > 0 ||
              dataResponse.data.mesEmailNotFormat.length > 0 ||
              dataResponse.data.mesFillAll.length > 0 ||
              dataResponse.data.mesModelNotFormat.length > 0 ||
              dataResponse.data.mesWarningSuperAdmin.length > 0
            ) {
              let DupUser = dataResponse.data.mesDupUser;
              let DupEmail = dataResponse.data.mesDupEmail;
              let EmailNotFormat = dataResponse.data.mesEmailNotFormat;
              let FillAll = dataResponse.data.mesFillAll;
              let mesModelNotFormat = dataResponse.data.mesModelNotFormat;
              let WarningSuperAdmin = dataResponse.data.mesWarningSuperAdmin;
              var htmlString = "";
              // let maxRowWarning = 20;
              // let countRowWarning = 0;
              const countDupUser = DupUser.length;
              const countDupEmail = DupEmail.length;
              const countEmailNotFormat = EmailNotFormat.length;
              const countFillAll = FillAll.length;
              const countModelNotFormat = mesModelNotFormat.length;
              const countWarningSuperAdmin = WarningSuperAdmin.length;

              for (let i = 0; i < countDupUser; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "duplicate username</br>";
                }
                htmlString += " -" + DupUser[i] + "</br>";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countDupEmail; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "duplicate email</br>";
                }
                htmlString += " -" + DupEmail[i] + "</br>";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countEmailNotFormat; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Email is not formatted correctly</br>";
                }
                htmlString += " -" + EmailNotFormat[i] + "</br>";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countFillAll; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Please fill the required fields</br>";
                }
                htmlString += " -" + FillAll[i] + "</br>";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countModelNotFormat; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Model is not formatted correctly</br>";
                }
                htmlString += " -" + mesModelNotFormat[i] + "</br>";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countWarningSuperAdmin; i++) {
                if (i == 0) {
                  htmlString +=
                    "This username is not allowed to be a SuperAdmin role.</br>";
                }
                htmlString += " -" + WarningSuperAdmin[i] + "</br>";
              }

              self.$swal.fire({
                icon: "warning",
                title: "Warning!",
                html: `${htmlString}`,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Close",
              });
            } else {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.Get();
            }
          } else {
            self.$swal.fire({
              icon: "warning",
              title: "Warning!",
              html: dataResponse.message,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Close",
            });
          }
          self.options.page = 1;
          self.Get();
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    linkDownload(modelType) {
      let self = this;
      let req = {
        modelType: modelType,
        filename: "User",
      };
      self.$call.DownloadTemplateUser(
        req,
        async (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameshow = `Template_User_${modelType}${await self.findTypeName(
              modelType
            )}`;
            fileLink.setAttribute("download", fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.flagTemplate = false;
        },
        (errorResource) => {
          self.flagTemplate = false;
          console.error(errorResource);
        }
      );
    },

    async findTypeName(modelType) {
      let type = "";
      switch (modelType) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },

    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || "Invalid Phone format";
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email) || "invalid email";
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    GetModel() {
      let self = this;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    Get() {
      try {
        let self = this;
        self.loadingTable = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        self.$call.GetTableUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.loadingTable = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetDefault() {
      try {
        let self = this;
        self.dialog = true;
        const { page, itemsPerPage } = this.options;
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          sortDesc: null,
          sortBy: null,
        };
        self.$call.GetTableUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    EditUser(temp) {
      let self = this;
      // self.oldPassword = self.decryptShiftData(temp.password, 7);
      self.Editdialog = true;
      self.edit.id = temp.userId;
      self.edit.username = temp.username;
      self.edit.firstname = temp.firstName;
      self.edit.lastname = temp.lastName;
      // self.edit.password = temp.password;
      //self.edit.password = self.decryptShiftData(temp.password, 7);
      // self.edit.employeename = temp.employeeName;
      self.edit.roleId =
        temp.roleId == null || temp.roleId == undefined ? 2 : temp.roleId;
      self.edit.userType = temp.userType;
      self.edit.email = temp.email;
      self.edit.phone = temp.mobile;
      self.edit.model = temp.model;
      self.edit.lockStatus = temp.isLock;
      (self.edit.password = ""), (self.edit.confirmpassword = "");
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.flagChangePassword = false;

      self.edit.vectordbName = temp.vectordbName;
      self.edit.dataIntegrationID = temp.dataIntegrationID;
      self.edit.productGroupID = temp.productGroupID;
      self.edit.intentGroupID = temp.intentGroupID;
      self.edit.flowGroupID = temp.flowGroupID;
      self.edit.communityGraphID = temp.communityGraphID;
      self.edit.metaCommunityGraphID = temp.metaCommunityGraphID;
      self.edit.metaVectordbName = temp.metaVectordbName;
      // Set custom page permission after nextTick to avoid roleId watcher resetting values
      this.$nextTick(() => {
        self.edit.isCustomPageAccess = temp.isCustomPageAccess || false;
        self.edit.customPagePermission = self.normalizePermissionList(temp.customPagePermission);
      });
    },
    UpdateUser() {
      try {
        let self = this;
        self.dialog = true;
        let emailvali = self.validateEmail(self.edit.email);
        // let phonevali = self.PhoneNumberValidation(self.edit.phone);
        if (
          self.edit.username != "" &&
          self.edit.lastname != "" &&
          self.edit.firstname != "" &&
          self.edit.email != "" &&
          // self.edit.phone != '' &&
          // ((self.edit.password != '' && self.flagChangePassword == false) ||
          // (self.edit.password != '' && self.edit.confirmpassword != '' && self.flagChangePassword == true && self.statusPassword == true && self.statusFormatPassword == true)) &&
          self.edit.roleId != null &&
          // self.edit.userType != "" &&
          emailvali /*&&
          phonevali*/
        ) {
          let tempUser = {
            userId: self.edit.id,
            username: self.edit.username,
            // password: self.flagChangePassword ? self.edit.password : "",
            idcard: 0,
            prefixId: 0,
            firstName: self.edit.firstname,
            lastName: self.edit.lastname,
            // roleId: 1,
            roleId: self.edit.roleId,
            // userType: self.edit.userType,
            mobile: self.edit.phone,
            eMail: self.edit.email,
            model: self.edit.roleId == 1 ? null : self.edit.model,
            lockStatus: self.edit.lockStatus,
            vectordbName: self.edit.vectordbName,
            databaseIntegrationID: self.edit.dataIntegrationID,
            productGroupID: self.edit.productGroupID,
            intentGroupID: self.edit.intentGroupID,
            flowGroupID: self.edit.flowGroupID,
            communityGraphID: self.edit.communityGraphID,
            metaCommunityGraphID: self.edit.metaCommunityGraphID,
            metaVectordbName: self.edit.metaVectordbName,
            isCustomPageAccess: self.edit.isCustomPageAccess,
            customPagePermission: self.edit.isCustomPageAccess ? self.sortPermissionByNavOrder(self.edit.customPagePermission, self.editAvailablePagesForRole) : []
          };
          self.$call.UpdateUser(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (Cookies.get("userId") == self.edit.id) {
                  Cookies.set(
                    "fullName",
                    `${self.edit.firstname} ${self.edit.lastname}`
                  );
                  store.state.fullName = `${self.edit.firstname} ${self.edit.lastname}`;
                  Cookies.set("username", self.edit.username);
                  if (self.oldPassword != self.edit.password) {
                    self.$call.ClearUserInfo();
                    self.$router.push("/login");
                  }
                }
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Editdialog = false;
                self.edit.name = null;
                self.edit.surname = null;
                self.edit.email = null;
                self.edit.department = null;
                self.edit.section = null;
                self.edit.status = null;
                self.edit.roleId = null;
                self.edit.userType = null;
                self.Get();
              } else if (dataResponse.status == 4) {
                self.$swal.fire({
                  icon: "warning",
                  title: this.$t("oneSuperAdmin"),
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (emailvali != true /*|| phonevali != true*/) {
            // alert("please fill correct format");
            self.$swal.fire({
              icon: "warning",
              title: this.$t("please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.username == "" ||
            self.edit.firstname == "" ||
            self.edit.lastname == "" ||
            self.edit.roleId == "" ||
            self.edit.userType == "" ||
            self.edit.confirmpassword == "" ||
            self.edit.password == null ||
            self.edit.confirmpassword == null
          ) {
            // alert("please fill all fields!!!");
            self.$swal.fire({
              icon: "warning",
              title: this.$t("please fill all fields!!!"),
              showConfirmButton: false,
              timer: 2000,
              
            });
          } else if (self.user.roleId == null) {
            // alert("Please fill correct format!");
            self.$swal.fire({
              icon: "warning",
              title: this.$t("please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Editdialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    DeleteUser(user) {
      let self = this;
      let id = user.userId;
      try {
        if (user.roleId == 0 && self.roleId != "0") {
          self.$swal.fire({
            icon: "warning",
            title: this.$t("notAuthoritySuperAdmin"),
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionUser"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteUser(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.totalTable = self.totalTable - 1;
                    self.Get();
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  } else if (dataResponse.status == 4) {
                    self.$swal.fire({
                      icon: "warning",
                      title: this.$t("oneSuperAdmin"),
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteUser");
      }
    },
    closeadd() {
      let self = this;

      Object.keys(self.form).forEach((f) => {
        self.$refs[f].reset();
      });

      self.Adddialog = false;
      self.user.model = null;
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.show1 = false;
      self.show2 = false;
    },
    AddUser() {
      try {
        let self = this;
        self.dialog = true;

        let emailvali = self.validateEmail(self.user.email);
        // let phonevali = self.PhoneNumberValidation(self.user.phone);
        if (
          self.user.username != null &&
          self.user.lastname != null &&
          self.user.firstname != null &&
          self.user.email != null &&
          // self.user.phone != null &&
          self.user.password != null &&
          self.user.confirmpassword != null &&
          self.user.roleId != null &&
          // self.user.userType != null &&
          self.statusPassword == true &&
          self.statusFormatPassword == true &&
          emailvali == true /*&&
            phonevali == true*/
        ) {
          let tempUser = {
            username: self.user.username,
            password: self.user.password,
            idCard: 0,
            prefixId: 0,
            firstName: self.user.firstname,
            lastName: self.user.lastname,
            // roleId: 1,
            roleId: self.user.roleId,
            // userType: self.user.userType,
            mobile: self.user.phone,
            eMail: self.user.email,
            model:
              self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.model,
            lockStatus: self.user.lockStatus,

            vectordbName : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.vectordbName,
            DatabaseIntegrationID : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.dataIntegrationID,
            ProductGroupID : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.productGroupID,
            IntentGroupID : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.intentGroupID,
            FlowGroupID : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.flowGroupID,
            CommunityGraphID : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.communityGraphID,
            MetaCommunityGraphID : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.metaCommunityGraphID,
            MetaVectordbName : self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.metaVectordbName,
            isCustomPageAccess: self.user.isCustomPageAccess,
            customPagePermission: self.user.isCustomPageAccess ? self.sortPermissionByNavOrder(self.user.customPagePermission, self.addAvailablePagesForRole) : []
          };
          self.$call.CreateUser(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Adddialog = false;
                self.user.firstname = null;
                self.user.lastname = null;
                self.user.username = null;
                self.user.email = null;
                self.user.phone = null;
                self.user.model = null;
                self.user.password = "";
                self.user.confirmpassword = "";
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.show1 = false;
                self.show2 = false;
                self.user.isCustomPageAccess = false;
                self.user.customPagePermission = [];
                self.dialog = false;
                self.totalTable = self.totalTable + 1;
                self.Get();
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (
            self.user.username == null &&
            self.user.firstname == null &&
            self.user.lastname == null &&
            self.user.password == null &&
            self.user.confirmpassword == null &&
            self.user.roleId == null &&
            self.user.userType == null &&
            emailvali != true /*&&phonevali != true*/
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.username == null ||
            self.user.firstname == null ||
            self.user.lastname == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (emailvali != true /*|| phonevali != true*/) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password != null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password != self.user.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            !self.checkLengthPassword ||
            !self.checkLowercaseLetter ||
            !self.checkUppercaseLetter ||
            !self.checkNumber ||
            !self.checkSpecialCharacter
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (self.user.roleId == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Adddialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "AddUser");
      }
    },
    decryptData(encryptedText, key) {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText;
    },
    decryptShiftData(encryptedText, shift) {
      let chars = encryptedText.split("");
      let decryptedChars = [];

      for (let i = 0; i < chars.length; i++) {
        let c = chars[i];

        if (/[a-zA-Z]/.test(c)) {
          let offset =
            c === c.toUpperCase() ? "A".charCodeAt(0) : "a".charCodeAt(0);
          c = String.fromCharCode(
            ((c.charCodeAt(0) - offset - shift + 26) % 26) + offset
          );
        } else if (/[0-9]/.test(c)) {
          c = String.fromCharCode(
            ((c.charCodeAt(0) - "0".charCodeAt(0) - shift + 10) % 10) +
              "0".charCodeAt(0)
          );
        }

        decryptedChars.push(c);
      }

      return decryptedChars.join("");
    },
    closeChangePassword() {
      let self = this;
      self.edit.password = "";
      self.edit.confirmpassword = "";
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.changPasswordDialog = false;
      self.show3 = false;
      self.show4 = false;
    },
    saveChangePassword() {
      try {
        let self = this;
        self.dialog = true;
        if (
          self.edit.password != "" &&
          self.edit.confirmpassword != "" &&
          self.edit.password != null &&
          self.edit.confirmpassword != null &&
          self.edit.password != undefined &&
          self.edit.confirmpassword != undefined &&
          self.edit.password == self.edit.confirmpassword &&
          self.checkPasswordMatch == true &&
          self.checkLengthPassword &&
          self.checkLowercaseLetter &&
          self.checkUppercaseLetter &&
          self.checkNumber &&
          self.checkSpecialCharacter
        ) {
          let temp = {
            userID: self.edit.id,
            password: self.edit.password,
          };
          self.$call.ChangePassword(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.edit.password = "";
                self.edit.confirmpassword = "";
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.changPasswordDialog = false;
                self.show3 = false;
                self.show4 = false;
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          // if ((self.edit.password == '' || self.edit.password == null || self.edit.password == undefined) &&
          //    (self.edit.confirmpassword != '' && self.edit.confirmpassword != null && self.edit.confirmpassword != undefined)) {
          //   self.$swal.fire({
          //     icon: 'warning',
          //     title: self.$t('warning'),
          //     text: self.$t('Please fill Password!'),
          //     showConfirmButton: false,
          //     timer: 2000,
          //   });
          // } else if ((self.edit.confirmpassword == '' || self.edit.confirmpassword == null || self.edit.confirmpassword == undefined) &&
          //   (self.edit.password != '' && self.edit.password != null && self.edit.password != undefined)) {
          //   self.$swal.fire({
          //     icon: 'warning',
          //     title: self.$t('warning'),
          //     text: self.$t('Please fill Confirm Password!'),
          //     showConfirmButton: false,
          //     timer: 2000,
          //   });
          // }
          if (self.edit.password != null && self.edit.confirmpassword == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password == null &&
            self.edit.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            !self.checkLengthPassword ||
            !self.checkLowercaseLetter ||
            !self.checkUppercaseLetter ||
            !self.checkNumber ||
            !self.checkSpecialCharacter
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password != self.edit.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.changPasswordDialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "saveChangePassword");
      }
    },
  },
};
</script>

<style scoped>
/* Base Card Styles */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.title {
  color: white;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.ChangePassword:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

/* Common Dialog Styles */
.template-dialog,
.add-user-dialog,
.edit-user-dialog,
.change-password-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
}

/* Common Header Styles */
/* .template-header,
.add-user-header,
.edit-user-header,
.change-password-header {
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.template-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.add-user-header {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
} */

/* .edit-user-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
} */

/* .change-password-header {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
} */

/* Common Header Content */
/* .header-content {
  display: flex;
  align-items: center;
  gap: 16px;
} */

/* .header-icon {
  font-size: 28px;
  opacity: 0.9;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: white;
} */
/* 
.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: white;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
} */

/* Common Content Styles */
.template-content,
.add-user-content,
.edit-user-content,
.change-password-content {
  padding: 24px;
  background-color: #fafafa;
}

.add-user-content,
.edit-user-content,
.change-password-content {
  max-height: 70vh;
  overflow-y: auto;
}

.change-password-content {
  contain: layout;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(var(--v-theme-primary), 0.1);
}

.section-divider {
  margin: 20px 0;
  opacity: 0.6;
}

.form-row {
  margin-bottom: 8px;
}

.form-row .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Input Styling */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: 60px;
}

.input-wrapper:has(.password-requirements) {
  min-height: 200px;
}

.input-wrapper:has(.password-match) {
  min-height: 120px;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

.modern-input :deep(.v-field) {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.change-password-content .modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
}

.change-password-content
  .modern-input
  :deep(.v-field--focused .v-field__outline) {
  border-color: #ff9800;
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.25;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

.help-icon {
  color: rgba(var(--v-theme-primary), 0.7);
  cursor: help;
  transition: color 0.2s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

.password-toggle {
  margin: 0 !important;
}

/* Password Requirements */
.password-requirements,
.password-match {
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.password-requirements {
  padding: 12px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password-match {
  padding: 8px 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  margin: 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 4px 6px;
  border-radius: 6px;
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInRequirement 0.4s ease-out forwards;
}

.requirement-item:nth-child(1) {
  animation-delay: 0.1s;
}
.requirement-item:nth-child(2) {
  animation-delay: 0.15s;
}
.requirement-item:nth-child(3) {
  animation-delay: 0.2s;
}
.requirement-item:nth-child(4) {
  animation-delay: 0.25s;
}
.requirement-item:nth-child(5) {
  animation-delay: 0.3s;
}

.requirement-item.valid {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
  border-left: 3px solid rgb(var(--v-theme-success));
}

.requirement-item:not(.valid) {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
  border-left: 3px solid rgb(var(--v-theme-error));
}

/* Password Strength Indicator */
.password-strength-wrapper {
  background: white;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.strength-label {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: rgb(var(--v-theme-on-surface));
  transition: all 0.3s ease;
}

.strength-text {
  font-weight: 700;
  margin-left: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.strength-bar {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.strength-bar :deep(.v-progress-linear__background) {
  background-color: rgba(var(--v-border-color), 0.15) !important;
  transition: all 0.3s ease;
}

.strength-bar :deep(.v-progress-linear__determinate) {
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.strength-bar :deep(.v-progress-linear__determinate)::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

/* Role Selection */
.role-selection-container-compact {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.role-radio-group-compact {
  margin: 0;
}

.role-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
}

.role-card-compact {
  position: relative;
  background: #f8f9fa;
  border: 1.5px solid rgba(var(--v-border-color), 0.2);
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.role-card-compact:hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact.selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #e0e0e0 !important;
  border-color: #bdbdbd !important;
}

.role-card-compact.disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  border-color: #bdbdbd !important;
  background: #e0e0e0 !important;
}

.role-badge {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.role-icon-compact {
  font-size: 20px !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.role-radio-compact {
  margin: 0;
  padding: 0;
}

.role-radio-compact :deep(.v-selection-control) {
  min-height: auto;
  margin: 0;
}

.role-radio-compact :deep(.v-selection-control__wrapper) {
  height: 16px;
  width: 16px;
}

.role-details {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
}

.role-title-compact {
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.2;
  text-align: center;
}

.role-chip {
  align-self: center;
  height: 25px !important;
}

/* Role Card Colors */
.role-card-compact:nth-child(1):hover {
  border-color: rgba(244, 67, 54, 0.4);
  background: rgba(244, 67, 54, 0.03);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.12);
}

.role-card-compact:nth-child(1).selected {
  border-color: #f44336;
  background: rgba(244, 67, 54, 0.08);
  box-shadow: 0 2px 12px rgba(244, 67, 54, 0.2);
}

.role-card-compact:nth-child(2):hover {
  border-color: rgba(255, 152, 0, 0.4);
  background: rgba(255, 152, 0, 0.03);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.12);
}

.role-card-compact:nth-child(2).selected {
  border-color: #ff9800;
  background: rgba(255, 152, 0, 0.08);
  box-shadow: 0 2px 12px rgba(255, 152, 0, 0.2);
}

.role-card-compact:nth-child(3):hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact:nth-child(3).selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact:nth-child(4):hover {
  border-color: rgba(156, 39, 176, 0.4);
  background: rgba(156, 39, 176, 0.03);
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.12);
}

.role-card-compact:nth-child(4).selected {
  border-color: #9c27b0;
  background: rgba(156, 39, 176, 0.08);
  box-shadow: 0 2px 12px rgba(156, 39, 176, 0.2);
}

/* Switch Wrapper */
.switch-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
}

.switch-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-success), 0.3) 0%,
    rgba(var(--v-theme-success), 0.1) 100%
  );
  transition: all 0.3s ease;
}

.switch-wrapper:has(.modern-switch input:checked)::before {
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-error), 0.3) 0%,
    rgba(var(--v-theme-error), 0.1) 100%
  );
}

.switch-wrapper:has(.modern-switch input:checked) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-error), 0.1);
}

.switch-wrapper:has(.modern-switch input:not(:checked)) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-success), 0.1);
}

.switch-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.switch-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.lock-icon-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(170, 213, 157, 0.242) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.lock-icon-container:has(.locked) {
  background: rgba(156, 61, 61, 0.242) !important;
}

.lock-icon {
  font-size: 24px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.lock-icon.locked {
  animation: lockShake 0.6s ease-in-out;
  transform-origin: center;
}

.lock-icon.unlocked {
  animation: unlockBounce 0.8s ease-out;
  transform-origin: center;
}

.switch-title {
  font-size: 1rem;
  font-weight: 700;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.switch-subtitle {
  font-size: 0.85rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-top: 2px;
  line-height: 1.4;
  max-width: 300px;
  transition: color 0.3s ease;
}

.switch-control {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.modern-switch {
  margin: 0;
}

.modern-switch :deep(.v-selection-control) {
  min-height: auto;
}

.modern-switch :deep(.v-switch__track) {
  background-color: rgba(var(--v-theme-surface-variant), 0.5) !important;
  border: 2px solid rgba(var(--v-border-color), 0.2);
  transition: all 0.3s ease;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
  border-color: rgba(var(--v-theme-error), 0.3);
}

.modern-switch :deep(.v-switch__thumb) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.switch-label {
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
}

.switch-label.locked-text {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
}

.switch-label.unlocked-text {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
}

/* Template Table */
.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.download-cell {
  text-align: center;
  padding: 16px 12px;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  min-width: 100px;
  height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Security Tips */
.security-tips {
  margin-top: 20px;
  animation: fadeInUp 0.5s ease-out 0.3s both;
}

.security-alert {
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-info), 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.security-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.15);
}

.alert-content {
  font-size: 0.875rem;
}

.tips-list {
  margin: 8px 0 0 16px;
  padding: 0;
}

.tips-list li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInTip 0.4s ease-out forwards;
}

.tips-list li:nth-child(1) {
  animation-delay: 0.9s;
}
.tips-list li:nth-child(2) {
  animation-delay: 1s;
}
.tips-list li:nth-child(3) {
  animation-delay: 1.1s;
}
.tips-list li:nth-child(4) {
  animation-delay: 1.2s;
}

/* Action Buttons */
.template-actions,
.add-user-actions,
.edit-user-actions,
.change-password-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.edit-user-actions {
  display: flex;
  align-items: center;
}

/* .dialog-action-btn, */
.close-dialog-action-btn,
.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
}

.close-dialog-action-btn {
  padding: 0 24px;
  height: 40px;
}

/* .dialog-action-btn {
  padding: 0 20px;
  height: 40px;
  min-width: 140px;
} */

.cancel-btn,
.save-btn {
  padding: 0 24px;
}

.cancel-btn:hover,
.close-dialog-action-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
  transform: translateY(-1px);
}

/* .dialog-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
} */

.save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.add-user-actions .save-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.add-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}
@media (max-width: 768px) {
  .add-user-actions {
    flex-direction: column;
    align-items: center;
  }
}
.edit-user-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.edit-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

.change-password-actions .save-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.change-password-actions .save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.change-password-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRequirement {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInTip {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes lockShake {
  0%,
  100% {
    transform: translateX(0) scale(1);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-2px) scale(1.05);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(2px) scale(1.05);
  }
}

@keyframes unlockBounce {
  0% {
    transform: scale(1) rotate(0deg);
  }
  20% {
    transform: scale(1.2) rotate(-5deg);
  }
  40% {
    transform: scale(1.1) rotate(5deg);
  }
  60% {
    transform: scale(1.15) rotate(-3deg);
  }
  80% {
    transform: scale(1.05) rotate(2deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}

/* Vue Transitions */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
  filter: blur(2px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px) scale(0.98);
  filter: blur(1px);
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
  filter: blur(0);
}

.expand-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scaleY(0.8);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px) scaleY(0.9);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  max-height: 200px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  /* Dialog sizes */
  .template-dialog,
  .add-user-dialog,
  .edit-user-dialog,
  .change-password-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  /* Headers */
  .template-header,
  .add-user-header,
  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 24px;
  }

  /* .dialog-title {
    font-size: 1.25rem;
  } */

  /* Content */
  .template-content,
  .add-user-content,
  .edit-user-content,
  .change-password-content {
    padding: 16px;
  }

  .add-user-content,
  .edit-user-content,
  .change-password-content {
    max-height: 60vh;
  }

  /* Role cards */
  .role-cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .role-card-compact {
    padding: 8px;
    min-height: 60px;
  }

  .role-icon-compact {
    font-size: 18px !important;
  }

  .role-title-compact {
    font-size: 0.8rem;
  }

  /* Switch */
  .switch-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .switch-control {
    align-items: flex-start;
    width: 100%;
  }

  .lock-icon-container {
    width: 40px;
    height: 40px;
  }

  .lock-icon {
    font-size: 20px !important;
  }

  .switch-title {
    font-size: 0.9rem;
  }

  .switch-subtitle {
    font-size: 0.8rem;
    max-width: none;
  }

  /* Password */
  .password-requirements {
    min-height: 100px;
    padding: 10px;
  }

  .password-strength-wrapper {
    min-height: 70px;
    padding: 12px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 180px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 100px;
  }

  .requirement-item {
    font-size: 0.75rem;
    padding: 3px 5px;
  }

  .strength-label {
    font-size: 0.8rem;
  }

  /* Buttons */
  /* .dialog-action-btn, */
  .cancel-btn,
  .save-btn {
    min-width: 100px;
    height: 40px;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  .dialog-action-btn {
    width: 100%;
    order: 1;
  }

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }

  /* Template */
  .download-btn {
    font-size: 0.8rem;
    min-width: 90px;
    height: 32px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .download-cell {
    padding: 12px 8px;
  }

  .tips-list {
    font-size: 0.8rem;
  }

  /* Animations */
  .slide-fade-enter-active,
  .expand-fade-enter-active {
    transition-duration: 0.3s;
  }

  .requirement-item {
    animation-duration: 0.3s;
  }
}

@media (max-width: 480px) {
  /* Dialog sizes */
  .template-dialog,
  .add-user-dialog,
  .edit-user-dialog,
  .change-password-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  /* Headers */
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  /* Role cards */
  .role-selection-container-compact {
    padding: 8px;
  }

  .role-cards-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4px;
  }

  .role-card-compact {
    padding: 6px;
    min-height: 55px;
  }

  .role-icon-compact {
    font-size: 16px !important;
  }

  .role-title-compact {
    font-size: 0.75rem;
  }

  /* Switch */
  .switch-wrapper {
    padding: 16px;
  }

  .switch-info {
    gap: 12px;
  }

  .lock-icon-container {
    width: 36px;
    height: 36px;
  }

  .lock-icon {
    font-size: 18px !important;
  }

  .switch-title {
    font-size: 0.85rem;
  }

  .switch-subtitle {
    font-size: 0.75rem;
  }

  .switch-label {
    font-size: 0.8rem;
  }

  /* Password */
  .password-requirements {
    min-height: 90px;
    padding: 8px;
  }

  .password-strength-wrapper {
    min-height: 60px;
    padding: 10px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 160px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 90px;
  }

  /* Buttons */
  .add-user-actions,
  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }

  .dialog-action-btn,
  .cancel-btn,
  .save-btn {
    height: 40px;
    font-size: 0.9rem;
  }

  /* Others */
  .section-title {
    font-size: 1rem;
  }

  .download-btn {
    font-size: 0.75rem;
    min-width: 80px;
    height: 30px;
  }
}

/* Accessibility and Performance */
.role-card-compact:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 1px;
}

.modern-switch:focus-within .lock-icon-container {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.change-password-dialog :deep(.v-btn:focus-visible) {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.switch-wrapper:hover .lock-icon-container {
  transform: scale(1.05);
}

.switch-wrapper:active .lock-icon-container {
  transform: scale(0.95);
}

.switch-wrapper:active .lock-icon {
  transform: scale(0.9);
}

/* Reduce Motion for Accessibility */
@media (prefers-reduced-motion: reduce) {
  .slide-fade-enter-active,
  .slide-fade-leave-active,
  .expand-fade-enter-active,
  .expand-fade-leave-active,
  .requirement-item,
  .strength-bar :deep(.v-progress-linear__determinate),
  .security-tips,
  .tips-list li {
    animation: none;
    transition: none;
  }

  .requirement-item,
  .tips-list li {
    opacity: 1;
    transform: none;
  }
}

/* Hidden/Unused Styles */
.role-selection-container,
.role-radio-group,
.role-card {
  display: none;
}

.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 300px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.control-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.template-btn,
.import-btn {
  width: 120px;
  height: 36px;
}
.template-btn:hover {
  background: transparent !important;
  box-shadow: none;
  transform: translate(0);
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}

/* Custom Page Access styles */
.custom-page-access-wrapper {
  border: 1px solid rgba(var(--v-theme-primary), 0.15);
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.02) 0%, rgba(var(--v-theme-primary), 0.06) 100%);
}

.page-selector-card {
  border-color: rgba(var(--v-theme-primary), 0.2) !important;
  background: rgba(var(--v-theme-primary), 0.02);
}

.page-tree-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;
}

.page-tree-container::-webkit-scrollbar {
  width: 5px;
}

.page-tree-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 3px;
}

.page-tree-container::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.25);
  border-radius: 3px;
}

.group-checkbox :deep(.v-label) {
  font-weight: 600;
  font-size: 14px;
}

.child-checkbox {
  margin-bottom: 0 !important;
}

.child-checkbox :deep(.v-label) {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
}

/* Mode legend */
.mode-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
.mode-legend .legend-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Permission row — uniform layout for group / standalone / child */
.permission-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background-color 0.15s ease;
}
.permission-row:hover {
  background: rgba(var(--v-theme-primary), 0.04);
}
.permission-row.group-row {
  background: rgba(var(--v-theme-primary), 0.05);
  border: 1px solid rgba(var(--v-theme-primary), 0.1);
  font-weight: 600;
  font-size: 14px;
}
.permission-row.child-row {
  padding-left: 32px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.75);
}
.permission-row .permission-label {
  display: inline-flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.permission-row .group-label-text {
  font-weight: 600;
}
.permission-row .child-label-text {
  font-size: 13px;
}

.children-container {
  margin-top: 4px;
  border-left: 2px dashed rgba(var(--v-theme-primary), 0.15);
  margin-left: 12px;
  padding-left: 4px;
}

/* Permission toggle (v-btn-toggle wrapper) */
.permission-toggle {
  flex-shrink: 0;
  /* border-radius: 999px !important; */
  overflow: hidden;
}
.permission-toggle :deep(.v-btn) {
  min-width: 36px !important;
  padding: 0 10px !important;
  height: 28px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.permission-toggle :deep(.v-btn:first-child) {
  border-top-left-radius: 999px !important;
  border-bottom-left-radius: 999px !important;
}
.permission-toggle :deep(.v-btn:last-child) {
  border-top-right-radius: 999px !important;
  border-bottom-right-radius: 999px !important;
}

.bulk-actions .v-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
}

</style>
